export default {
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[117.032273, 31.256607],
						[117.042235, 31.252469],
						[117.055104, 31.235386],
						[117.071358, 31.236871],
						[117.079174, 31.221643],
						[117.100147, 31.190488],
						[117.109394, 31.169571],
						[117.12212, 31.148543],
						[117.121977, 31.129264],
						[117.117163, 31.12443],
						[117.122787, 31.101798],
						[117.117306, 31.08506],
						[117.13599, 31.073155],
						[117.156248, 31.072411],
						[117.175314, 31.087451],
						[117.190566, 31.0697],
						[117.212063, 31.057315],
						[117.225409, 31.03706],
						[117.229365, 31.022331],
						[117.247049, 31.011217],
						[117.277315, 30.984728],
						[117.28518, 30.98244],
						[117.298002, 30.985526],
						[117.306343, 30.999994],
						[117.314065, 30.999835],
						[117.324789, 30.989249],
						[117.337802, 30.987653],
						[117.348907, 30.992122],
						[117.356534, 30.987919],
						[117.369498, 30.963659],
						[117.365161, 30.959029],
						[117.371453, 30.950994],
						[117.383273, 30.951899],
						[117.385466, 30.964829],
						[117.412968, 30.97728],
						[117.441567, 30.967916],
						[117.44824, 30.982706],
						[117.45925, 30.988983],
						[117.494808, 30.996005],
						[117.507534, 31.003452],
						[117.493616, 31.029988],
						[117.483941, 31.035837],
						[117.485037, 31.041952],
						[117.494427, 31.046364],
						[117.51211, 31.047162],
						[117.524169, 31.066458],
						[117.528697, 31.079267],
						[117.524217, 31.095156],
						[117.512206, 31.10658],
						[117.517401, 31.114974],
						[117.527315, 31.118055],
						[117.530842, 31.137018],
						[117.552387, 31.145197],
						[117.558774, 31.159111],
						[117.555008, 31.177216],
						[117.532463, 31.19224],
						[117.525266, 31.200573],
						[117.540328, 31.205987],
						[117.555723, 31.215062],
						[117.561395, 31.233263],
						[117.573121, 31.248066],
						[117.575409, 31.255758],
						[117.57212, 31.271034],
						[117.602673, 31.275754],
						[117.6164, 31.294156],
						[117.633845, 31.297125],
						[117.647763, 31.32077],
						[117.656104, 31.34955],
						[117.677124, 31.391459],
						[117.692901, 31.407349],
						[117.697, 31.431549],
						[117.705628, 31.458707],
						[117.720642, 31.467916],
						[117.740613, 31.46437],
						[117.757105, 31.471727],
						[117.768497, 31.466011],
						[117.778459, 31.4812],
						[117.795904, 31.483423],
						[117.81559, 31.479665],
						[117.830985, 31.486016],
						[117.850146, 31.483634],
						[117.890137, 31.501254],
						[117.900146, 31.504059],
						[117.917782, 31.502366],
						[117.934226, 31.488556],
						[117.945523, 31.487815],
						[117.965399, 31.498239],
						[117.952386, 31.519823],
						[117.939565, 31.525113],
						[117.952148, 31.536961],
						[117.941662, 31.540663],
						[117.92803, 31.538441],
						[117.919784, 31.54923],
						[117.908297, 31.54685],
						[117.907248, 31.556686],
						[117.913921, 31.564987],
						[117.928268, 31.568212],
						[117.935323, 31.58053],
						[117.929603, 31.587138],
						[117.936037, 31.588935],
						[117.932129, 31.604474],
						[117.937181, 31.610446],
						[117.934608, 31.618108],
						[117.941138, 31.626932],
						[117.96273, 31.627143],
						[117.960775, 31.616681],
						[117.971929, 31.620486],
						[117.973311, 31.63845],
						[117.969021, 31.642148],
						[117.963873, 31.659368],
						[117.967639, 31.662168],
						[117.949288, 31.671357],
						[117.939183, 31.671357],
						[117.941424, 31.679067],
						[117.932272, 31.681813],
						[117.913206, 31.704042],
						[117.913063, 31.715339],
						[117.92007, 31.734129],
						[117.915256, 31.75033],
						[117.924741, 31.76141],
						[117.909441, 31.767424],
						[117.905961, 31.777553],
						[117.913445, 31.787522],
						[117.901385, 31.811782],
						[117.908011, 31.832556],
						[117.913874, 31.840885],
						[117.935751, 31.855433],
						[117.94171, 31.868873],
						[117.951862, 31.906229],
						[117.929698, 31.920819],
						[117.91516, 31.922189],
						[117.900051, 31.92914],
						[117.886562, 31.926771],
						[117.868116, 31.928982],
						[117.868592, 31.945307],
						[117.865637, 31.954311],
						[117.846428, 31.962576],
						[117.844665, 31.974526],
						[117.836085, 31.979053],
						[117.82946, 31.994789],
						[117.810918, 32.002262],
						[117.832987, 32.015259],
						[117.833416, 32.03383],
						[117.842377, 32.041773],
						[117.864207, 32.047086],
						[117.885084, 32.064125],
						[117.868259, 32.075957],
						[117.866495, 32.085841],
						[117.858059, 32.093832],
						[117.868163, 32.097354],
						[117.867019, 32.106553],
						[117.851624, 32.105975],
						[117.855342, 32.123319],
						[117.872739, 32.141028],
						[117.863921, 32.195498],
						[117.847191, 32.217445],
						[117.833225, 32.221697],
						[117.819879, 32.230516],
						[117.807391, 32.221225],
						[117.791471, 32.219755],
						[117.781605, 32.231986],
						[117.770928, 32.239177],
						[117.757439, 32.240646],
						[117.741281, 32.247154],
						[117.729126, 32.245632],
						[117.712015, 32.236553],
						[117.707487, 32.243901],
						[117.697239, 32.248781],
						[117.673216, 32.250985],
						[117.672215, 32.261061],
						[117.652434, 32.260799],
						[117.631748, 32.248886],
						[117.631986, 32.256915],
						[117.622549, 32.249988],
						[117.613921, 32.250198],
						[117.605437, 32.238914],
						[117.59395, 32.239124],
						[117.576076, 32.230726],
						[117.553864, 32.215975],
						[117.498145, 32.203532],
						[117.48232, 32.212405],
						[117.46864, 32.223482],
						[117.449098, 32.233928],
						[117.435371, 32.236762],
						[117.427268, 32.242536],
						[117.425218, 32.259539],
						[117.40825, 32.26762],
						[117.395761, 32.283727],
						[117.412587, 32.319602],
						[117.423359, 32.334546],
						[117.444903, 32.343512],
						[117.44171, 32.366524],
						[117.405342, 32.375119],
						[117.392568, 32.388115],
						[117.369546, 32.382508],
						[117.359251, 32.384971],
						[117.377315, 32.398385],
						[117.382415, 32.409177],
						[117.38232, 32.43102],
						[117.39376, 32.452805],
						[117.408297, 32.468565],
						[117.394046, 32.478302],
						[117.380938, 32.464377],
						[117.365113, 32.455895],
						[117.32722, 32.441704],
						[117.30844, 32.451234],
						[117.293045, 32.443799],
						[117.28294, 32.442751],
						[117.266877, 32.451444],
						[117.244951, 32.460136],
						[117.219546, 32.463015],
						[117.209012, 32.472544],
						[117.211586, 32.476261],
						[117.209632, 32.493953],
						[117.211205, 32.516194],
						[117.2011, 32.534035],
						[117.167115, 32.534296],
						[117.157773, 32.535866],
						[117.150766, 32.526606],
						[117.139613, 32.520432],
						[117.127649, 32.524618],
						[117.115828, 32.521949],
						[117.110681, 32.527862],
						[117.09457, 32.531995],
						[117.084847, 32.530477],
						[117.07355, 32.51656],
						[117.079603, 32.511589],
						[117.074694, 32.491754],
						[117.068116, 32.482804],
						[117.070786, 32.469141],
						[117.06702, 32.461445],
						[117.047668, 32.438824],
						[117.048336, 32.430601],
						[117.039661, 32.415987],
						[117.026601, 32.413787],
						[117.009203, 32.404567],
						[117.00458, 32.386228],
						[117.017687, 32.383084],
						[117.042282, 32.38539],
						[117.045619, 32.381145],
						[117.043712, 32.347863],
						[117.037897, 32.342148],
						[117.043331, 32.332973],
						[117.052053, 32.33549],
						[117.057297, 32.32815],
						[117.047621, 32.320179],
						[117.035705, 32.29469],
						[117.038374, 32.281156],
						[117.046238, 32.276329],
						[117.05763, 32.284146],
						[117.067354, 32.280054],
						[117.072215, 32.266256],
						[117.059727, 32.23461],
						[117.047239, 32.225162],
						[117.013636, 32.2228],
						[117.003102, 32.212458],
						[117.004389, 32.202902],
						[117.025314, 32.190877],
						[117.024456, 32.177642],
						[117.019022, 32.168923],
						[117.007392, 32.16199],
						[116.983274, 32.161937],
						[116.978412, 32.152271],
						[116.985943, 32.128206],
						[116.997573, 32.117696],
						[117.010299, 32.115015],
						[117.020309, 32.095514],
						[117.02355, 32.074432],
						[117.030557, 32.064599],
						[117.047001, 32.051767],
						[117.046715, 32.041247],
						[117.040757, 32.024256],
						[117.029937, 32.006998],
						[117.020738, 32.001052],
						[116.996572, 31.993421],
						[116.996667, 32.006419],
						[116.985562, 32.013944],
						[116.971358, 32.016311],
						[116.96254, 32.013154],
						[116.957106, 32.022362],
						[116.940423, 32.027728],
						[116.923789, 32.013523],
						[116.929175, 31.998736],
						[116.937421, 31.989474],
						[116.921024, 31.980579],
						[116.879175, 31.974315],
						[116.865352, 31.96942],
						[116.859346, 31.960523],
						[116.841424, 31.94815],
						[116.831606, 31.935881],
						[116.810157, 31.921188],
						[116.790042, 31.922557],
						[116.771072, 31.911286],
						[116.764256, 31.904227],
						[116.716067, 31.884207],
						[116.714113, 31.878938],
						[116.721596, 31.87135],
						[116.724647, 31.85828],
						[116.740567, 31.857911],
						[116.732607, 31.848371],
						[116.702006, 31.832082],
						[116.692521, 31.820272],
						[116.694809, 31.809356],
						[116.714113, 31.791847],
						[116.719785, 31.779083],
						[116.728746, 31.782406],
						[116.734752, 31.77481],
						[116.731129, 31.76542],
						[116.752101, 31.765525],
						[116.758012, 31.762465],
						[116.759442, 31.7469],
						[116.752149, 31.728746],
						[116.762254, 31.711327],
						[116.763255, 31.685879],
						[116.767926, 31.672097],
						[116.757583, 31.659157],
						[116.75315, 31.647061],
						[116.754628, 31.636918],
						[116.765638, 31.618584],
						[116.766782, 31.589358],
						[116.763255, 31.58238],
						[116.767497, 31.571331],
						[116.789756, 31.550605],
						[116.792854, 31.543941],
						[116.804485, 31.539235],
						[116.806725, 31.532624],
						[116.815733, 31.531936],
						[116.829747, 31.519083],
						[116.845476, 31.526488],
						[116.879318, 31.531672],
						[116.902054, 31.528234],
						[116.934561, 31.537754],
						[116.95253, 31.532042],
						[116.966925, 31.539816],
						[116.975457, 31.540239],
						[116.987135, 31.533787],
						[116.990662, 31.537542],
						[116.990852, 31.558536],
						[117.002101, 31.56081],
						[117.006868, 31.548013],
						[117.039613, 31.538864],
						[117.055009, 31.544735],
						[117.065971, 31.553513],
						[117.112301, 31.540081],
						[117.124265, 31.54447],
						[117.132082, 31.542884],
						[117.13375, 31.551028],
						[117.144999, 31.554835],
						[117.153817, 31.545158],
						[117.187039, 31.552085],
						[117.198288, 31.551979],
						[117.220023, 31.540239],
						[117.228316, 31.544788],
						[117.242282, 31.508185],
						[117.251386, 31.502947],
						[117.250719, 31.49681],
						[117.237277, 31.490461],
						[117.184513, 31.492842],
						[117.166448, 31.490619],
						[117.149194, 31.483317],
						[117.142473, 31.472045],
						[117.113064, 31.438485],
						[117.094379, 31.408831],
						[117.074837, 31.374401],
						[117.074074, 31.360678],
						[117.081367, 31.345947],
						[117.073693, 31.335453],
						[117.070023, 31.321724],
						[117.070786, 31.301102],
						[117.063874, 31.289436],
						[117.045809, 31.282967],
						[117.045285, 31.269018],
						[117.032273, 31.256607]
					]
				]
			]
		},
		"properties": {
			"adcode": 340100,
			"name": "合肥市",
			"center": [117.283042, 31.86119],
			"centroid": [117.360447, 31.762594],
			"childrenNum": 9,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 0,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[118.656866, 31.304654],
						[118.617543, 31.294103],
						[118.598001, 31.295004],
						[118.575122, 31.291345],
						[118.572548, 31.300306],
						[118.55515, 31.318862],
						[118.55129, 31.331955],
						[118.557724, 31.346371],
						[118.543663, 31.365606],
						[118.522929, 31.381924],
						[118.524979, 31.401788],
						[118.510775, 31.406289],
						[118.490946, 31.403588],
						[118.484512, 31.392465],
						[118.470403, 31.393737],
						[118.461347, 31.399722],
						[118.444998, 31.393472],
						[118.44352, 31.405389],
						[118.436371, 31.425777],
						[118.430031, 31.436155],
						[118.424598, 31.456166],
						[118.431795, 31.461512],
						[118.431747, 31.472997],
						[118.420355, 31.481465],
						[118.415255, 31.49771],
						[118.392853, 31.507868],
						[118.376552, 31.532518],
						[118.347953, 31.465058],
						[118.340089, 31.453519],
						[118.326171, 31.444149],
						[118.317305, 31.44399],
						[118.314636, 31.45336],
						[118.316781, 31.474267],
						[118.321976, 31.485487],
						[118.311204, 31.496757],
						[118.309965, 31.506598],
						[118.304054, 31.507815],
						[118.303149, 31.497233],
						[118.291948, 31.499403],
						[118.267686, 31.510195],
						[118.269831, 31.515327],
						[118.249955, 31.529291],
						[118.248239, 31.533576],
						[118.219593, 31.525483],
						[118.202434, 31.526541],
						[118.198144, 31.535004],
						[118.18537, 31.538071],
						[118.167877, 31.531724],
						[118.157153, 31.522098],
						[118.135084, 31.51702],
						[118.136657, 31.499244],
						[118.144903, 31.477337],
						[118.15067, 31.468287],
						[118.14109, 31.471568],
						[118.127696, 31.461353],
						[118.131652, 31.437267],
						[118.148096, 31.437002],
						[118.171214, 31.429484],
						[118.162682, 31.413757],
						[118.168592, 31.403376],
						[118.16516, 31.399139],
						[117.991233, 31.438537],
						[117.97965, 31.432872],
						[117.974646, 31.437584],
						[117.976076, 31.448226],
						[117.969355, 31.45569],
						[117.968354, 31.465641],
						[117.98027, 31.466805],
						[117.986895, 31.474479],
						[117.963016, 31.486545],
						[117.965399, 31.498239],
						[117.945523, 31.487815],
						[117.934226, 31.488556],
						[117.917782, 31.502366],
						[117.900146, 31.504059],
						[117.890137, 31.501254],
						[117.850146, 31.483634],
						[117.830985, 31.486016],
						[117.81559, 31.479665],
						[117.795904, 31.483423],
						[117.778459, 31.4812],
						[117.768497, 31.466011],
						[117.757105, 31.471727],
						[117.740613, 31.46437],
						[117.720642, 31.467916],
						[117.705628, 31.458707],
						[117.697, 31.431549],
						[117.692901, 31.407349],
						[117.677124, 31.391459],
						[117.656104, 31.34955],
						[117.647763, 31.32077],
						[117.633845, 31.297125],
						[117.6164, 31.294156],
						[117.602673, 31.275754],
						[117.57212, 31.271034],
						[117.575409, 31.255758],
						[117.573121, 31.248066],
						[117.561395, 31.233263],
						[117.555723, 31.215062],
						[117.540328, 31.205987],
						[117.525266, 31.200573],
						[117.532463, 31.19224],
						[117.555008, 31.177216],
						[117.558774, 31.159111],
						[117.552387, 31.145197],
						[117.530842, 31.137018],
						[117.527315, 31.118055],
						[117.517401, 31.114974],
						[117.512206, 31.10658],
						[117.524217, 31.095156],
						[117.528697, 31.079267],
						[117.524169, 31.066458],
						[117.51211, 31.047162],
						[117.494427, 31.046364],
						[117.485037, 31.041952],
						[117.483941, 31.035837],
						[117.493616, 31.029988],
						[117.507534, 31.003452],
						[117.523168, 30.994569],
						[117.536943, 30.992015],
						[117.532892, 30.973662],
						[117.54905, 30.967596],
						[117.560966, 30.974194],
						[117.568926, 30.968607],
						[117.583512, 30.970735],
						[117.592568, 30.978131],
						[117.62641, 30.972119],
						[117.650671, 30.957646],
						[117.65129, 30.950409],
						[117.66049, 30.940031],
						[117.66721, 30.956049],
						[117.665828, 30.966639],
						[117.683082, 30.968767],
						[117.686181, 30.98526],
						[117.693759, 30.98893],
						[117.700432, 31.002494],
						[117.697525, 31.0101],
						[117.70763, 31.01127],
						[117.718306, 31.019087],
						[117.721023, 31.0101],
						[117.731414, 31.00994],
						[117.752339, 31.057688],
						[117.767496, 31.096113],
						[117.781319, 31.111468],
						[117.807391, 31.129742],
						[117.831938, 31.139143],
						[117.850718, 31.140205],
						[117.869879, 31.133141],
						[117.88027, 31.122039],
						[117.890423, 31.086016],
						[117.897954, 31.07831],
						[117.923788, 31.068318],
						[117.935466, 31.067681],
						[117.95863, 31.074643],
						[117.973311, 31.084316],
						[117.985513, 31.079745],
						[118.005818, 31.078204],
						[118.021881, 31.064704],
						[118.009679, 31.045407],
						[118.013778, 31.034508],
						[118.025933, 31.030414],
						[118.03251, 31.017173],
						[118.070975, 31.011376],
						[118.083654, 30.993824],
						[118.097572, 30.985579],
						[118.105198, 30.970948],
						[118.124836, 30.967862],
						[118.143807, 30.970682],
						[118.159059, 30.963925],
						[118.160346, 30.952697],
						[118.152911, 30.932207],
						[118.154579, 30.923211],
						[118.164779, 30.907186],
						[118.1572, 30.901383],
						[118.134369, 30.902075],
						[118.099097, 30.885515],
						[118.079412, 30.866608],
						[118.056914, 30.872254],
						[118.039612, 30.857553],
						[118.048144, 30.855156],
						[118.041566, 30.843276],
						[118.024217, 30.845673],
						[118.013397, 30.862347],
						[117.993473, 30.854623],
						[117.980413, 30.843808],
						[117.989612, 30.828836],
						[117.966781, 30.799099],
						[117.968783, 30.794941],
						[117.983702, 30.794035],
						[117.997477, 30.778949],
						[118.030461, 30.774097],
						[118.051671, 30.758635],
						[118.071357, 30.746849],
						[118.095952, 30.738849],
						[118.115732, 30.71938],
						[118.124979, 30.717833],
						[118.128506, 30.701295],
						[118.134941, 30.700281],
						[118.126075, 30.690783],
						[118.105723, 30.662978],
						[118.099574, 30.651341],
						[118.100956, 30.641251],
						[118.1368, 30.652195],
						[118.153578, 30.666554],
						[118.171214, 30.691637],
						[118.205437, 30.702148],
						[118.218354, 30.709458],
						[118.229221, 30.709244],
						[118.242901, 30.703482],
						[118.267591, 30.714206],
						[118.278745, 30.712659],
						[118.293282, 30.699961],
						[118.30496, 30.698146],
						[118.314445, 30.705083],
						[118.297191, 30.715966],
						[118.294712, 30.722421],
						[118.275694, 30.736449],
						[118.276647, 30.743169],
						[118.294569, 30.757088],
						[118.297906, 30.772391],
						[118.307582, 30.77639],
						[118.302577, 30.793822],
						[118.305008, 30.800964],
						[118.312872, 30.795101],
						[118.306724, 30.806934],
						[118.318687, 30.821749],
						[118.33823, 30.826812],
						[118.34762, 30.824414],
						[118.358916, 30.84578],
						[118.376409, 30.845513],
						[118.409536, 30.84871],
						[118.424502, 30.841091],
						[118.4368, 30.824733],
						[118.429841, 30.813916],
						[118.419498, 30.813649],
						[118.4317, 30.796434],
						[118.446476, 30.800911],
						[118.455198, 30.790144],
						[118.451671, 30.779162],
						[118.48027, 30.76642],
						[118.480699, 30.780602],
						[118.48475, 30.79025],
						[118.502863, 30.801497],
						[118.503101, 30.810451],
						[118.495522, 30.819884],
						[118.482224, 30.822549],
						[118.477982, 30.833579],
						[118.490899, 30.842849],
						[118.490041, 30.848656],
						[118.498239, 30.859843],
						[118.485513, 30.864051],
						[118.47741, 30.857553],
						[118.483987, 30.870762],
						[118.472119, 30.875077],
						[118.475742, 30.88184],
						[118.485846, 30.87726],
						[118.492948, 30.883491],
						[118.489707, 30.900052],
						[118.511537, 30.914054],
						[118.509154, 30.928694],
						[118.495713, 30.941042],
						[118.515255, 30.937582],
						[118.510251, 30.9511],
						[118.550956, 30.970682],
						[118.570975, 30.972278],
						[118.582462, 30.981855],
						[118.581223, 30.994728],
						[118.572262, 31.016269],
						[118.584273, 31.026107],
						[118.596142, 31.047853],
						[118.603768, 31.044238],
						[118.600956, 31.028021],
						[118.606819, 31.020204],
						[118.627314, 31.020576],
						[118.650003, 31.036848],
						[118.663396, 31.054445],
						[118.682653, 31.074909],
						[118.676123, 31.081393],
						[118.676838, 31.08963],
						[118.685513, 31.096272],
						[118.683082, 31.111893],
						[118.690327, 31.124961],
						[118.702004, 31.135797],
						[118.717305, 31.144188],
						[118.733558, 31.149446],
						[118.718401, 31.173978],
						[118.708963, 31.177004],
						[118.695045, 31.189108],
						[118.682986, 31.214054],
						[118.66821, 31.22488],
						[118.663587, 31.236871],
						[118.647286, 31.245519],
						[118.651861, 31.261009],
						[118.66006, 31.269761],
						[118.661442, 31.290762],
						[118.656866, 31.304654]
					]
				]
			]
		},
		"properties": {
			"adcode": 340200,
			"name": "芜湖市",
			"center": [118.376451, 31.326319],
			"centroid": [118.13998, 31.160935],
			"cp": [118.11, 31.25],
			"childrenNum": 7,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 1,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[116.735657, 32.928663],
						[116.757869, 32.923767],
						[116.761301, 32.916371],
						[116.768403, 32.921476],
						[116.78499, 32.917204],
						[116.790996, 32.905014],
						[116.804866, 32.902566],
						[116.817831, 32.894021],
						[116.836467, 32.890843],
						[116.840614, 32.88657],
						[116.834179, 32.877607],
						[116.882225, 32.8443],
						[116.889232, 32.847271],
						[116.898336, 32.842996],
						[116.897239, 32.834289],
						[116.923312, 32.816508],
						[116.921072, 32.80952],
						[116.935037, 32.808737],
						[116.960919, 32.791786],
						[116.991901, 32.783752],
						[117.001958, 32.779161],
						[117.018736, 32.757403],
						[117.029318, 32.758081],
						[117.028698, 32.747696],
						[117.033607, 32.747435],
						[117.04009, 32.732873],
						[117.054437, 32.729688],
						[117.04376, 32.721388],
						[117.046334, 32.716167],
						[117.066448, 32.723946],
						[117.074837, 32.717525],
						[117.0909, 32.727757],
						[117.081701, 32.735117],
						[117.084561, 32.744095],
						[117.125266, 32.75782],
						[117.146143, 32.751349],
						[117.15906, 32.749888],
						[117.160395, 32.739919],
						[117.179365, 32.74112],
						[117.182034, 32.735952],
						[117.195905, 32.734699],
						[117.202673, 32.745399],
						[117.214112, 32.752027],
						[117.231796, 32.77217],
						[117.244665, 32.794602],
						[117.255819, 32.80566],
						[117.265542, 32.800862],
						[117.280366, 32.808842],
						[117.284942, 32.817447],
						[117.307678, 32.818959],
						[117.314017, 32.828241],
						[117.325218, 32.825894],
						[117.350814, 32.829232],
						[117.361729, 32.840129],
						[117.368354, 32.837783],
						[117.395857, 32.836427],
						[117.415113, 32.831995],
						[117.422168, 32.846593],
						[117.432272, 32.842266],
						[117.457773, 32.841484],
						[117.471167, 32.837157],
						[117.479222, 32.842944],
						[117.491281, 32.864681],
						[117.508249, 32.868747],
						[117.513588, 32.875261],
						[117.512253, 32.886153],
						[117.49967, 32.897408],
						[117.505151, 32.908557],
						[117.512396, 32.93283],
						[117.528602, 32.938976],
						[117.528173, 32.967041],
						[117.531224, 32.980576],
						[117.548526, 32.969592],
						[117.56864, 32.951369],
						[117.576839, 32.941059],
						[117.589994, 32.933924],
						[117.603483, 32.922257],
						[117.626886, 32.924809],
						[117.64619, 32.912308],
						[117.657534, 32.910745],
						[117.671834, 32.918819],
						[117.679174, 32.943871],
						[117.694665, 32.96928],
						[117.698287, 32.985],
						[117.707963, 33.00254],
						[117.718545, 33.006391],
						[117.737039, 33.001083],
						[117.746333, 33.009825],
						[117.762587, 33.040833],
						[117.773359, 33.047335],
						[117.787515, 33.045202],
						[117.800146, 33.031209],
						[117.822406, 33.02814],
						[117.860346, 33.035995],
						[117.880222, 33.041977],
						[117.886752, 33.046607],
						[117.893711, 33.035059],
						[117.890613, 33.031781],
						[117.89762, 33.019607],
						[117.895237, 33.013884],
						[117.879698, 33.002748],
						[117.899384, 32.990257],
						[117.913492, 32.987655],
						[117.937706, 33.008576],
						[117.947858, 33.014508],
						[117.970642, 33.001967],
						[117.982796, 33.01175],
						[118.003721, 33.002227],
						[118.011347, 33.001759],
						[118.031462, 33.014716],
						[118.0368, 33.027099],
						[118.018306, 33.034539],
						[118.005151, 33.031417],
						[117.99843, 33.040625],
						[118.004341, 33.055293],
						[118.018116, 33.06143],
						[118.032749, 33.073962],
						[118.061681, 33.07469],
						[118.072691, 33.081034],
						[118.065017, 33.09741],
						[118.07455, 33.117318],
						[118.073835, 33.135143],
						[118.05129, 33.124854],
						[118.044617, 33.127192],
						[118.050337, 33.133792],
						[118.067925, 33.135143],
						[118.070451, 33.140391],
						[118.046905, 33.138416],
						[118.03823, 33.135195],
						[118.037086, 33.15234],
						[118.025694, 33.155977],
						[118.017448, 33.1646],
						[118.005866, 33.170314],
						[118.001528, 33.178624],
						[117.989183, 33.179663],
						[117.981509, 33.201006],
						[117.993616, 33.205627],
						[117.993473, 33.211286],
						[117.977458, 33.226237],
						[117.953816, 33.223953],
						[117.942377, 33.225043],
						[117.938993, 33.234282],
						[117.948049, 33.252135],
						[117.939469, 33.262617],
						[117.970404, 33.277195],
						[117.98313, 33.296388],
						[117.985894, 33.320243],
						[117.992996, 33.332946],
						[117.978983, 33.334139],
						[117.972691, 33.330095],
						[117.952148, 33.32885],
						[117.916018, 33.330095],
						[117.909155, 33.344455],
						[117.897954, 33.340308],
						[117.894379, 33.330613],
						[117.870976, 33.329213],
						[117.859202, 33.324962],
						[117.85353, 33.304323],
						[117.846619, 33.295247],
						[117.824836, 33.299085],
						[117.809536, 33.296232],
						[117.808345, 33.283161],
						[117.793283, 33.277559],
						[117.775408, 33.282383],
						[117.737801, 33.275068],
						[117.728125, 33.284821],
						[117.710585, 33.282954],
						[117.692663, 33.291668],
						[117.690184, 33.304997],
						[117.677124, 33.309924],
						[117.66783, 33.327917],
						[117.642997, 33.333465],
						[117.631939, 33.343677],
						[117.62374, 33.345336],
						[117.609393, 33.339789],
						[117.58966, 33.323303],
						[117.577982, 33.32548],
						[117.56416, 33.333257],
						[117.539756, 33.327813],
						[117.528793, 33.339686],
						[117.507344, 33.346062],
						[117.484274, 33.345544],
						[117.477077, 33.347772],
						[117.433607, 33.379024],
						[117.424169, 33.399955],
						[117.40172, 33.424766],
						[117.391519, 33.456249],
						[117.365399, 33.470951],
						[117.34519, 33.475661],
						[117.320404, 33.476127],
						[117.309632, 33.490877],
						[117.261967, 33.497035],
						[117.24314, 33.501537],
						[117.241996, 33.489945],
						[117.231367, 33.47328],
						[117.208011, 33.453091],
						[117.202721, 33.423472],
						[117.15968, 33.457543],
						[117.154818, 33.439059],
						[117.139708, 33.442011],
						[117.128793, 33.434554],
						[117.126839, 33.422384],
						[117.134656, 33.419743],
						[117.14376, 33.409694],
						[117.133417, 33.387366],
						[117.125504, 33.380993],
						[117.107344, 33.392702],
						[117.108774, 33.398194],
						[117.094808, 33.398246],
						[117.08232, 33.406638],
						[117.060728, 33.392288],
						[117.051243, 33.371406],
						[117.062873, 33.373946],
						[117.084894, 33.365498],
						[117.096572, 33.353941],
						[117.093521, 33.346788],
						[117.080795, 33.344507],
						[117.074932, 33.333931],
						[117.064303, 33.332842],
						[117.065018, 33.321591],
						[117.092092, 33.316147],
						[117.099289, 33.307746],
						[117.095523, 33.284873],
						[117.034132, 33.293276],
						[117.025409, 33.29644],
						[117.012444, 33.279219],
						[117.002578, 33.278025],
						[116.986658, 33.281657],
						[116.974599, 33.278389],
						[116.953531, 33.286637],
						[116.937897, 33.301315],
						[116.923407, 33.30702],
						[116.904532, 33.299656],
						[116.878841, 33.299656],
						[116.869832, 33.286118],
						[116.849909, 33.281553],
						[116.841186, 33.284977],
						[116.820452, 33.302197],
						[116.807344, 33.30702],
						[116.801911, 33.303908],
						[116.800481, 33.27595],
						[116.805485, 33.275587],
						[116.813159, 33.250319],
						[116.825981, 33.230804],
						[116.826553, 33.210819],
						[116.821405, 33.202771],
						[116.815304, 33.155405],
						[116.805247, 33.156081],
						[116.791853, 33.169015],
						[116.777078, 33.151821],
						[116.77131, 33.15525],
						[116.756868, 33.141222],
						[116.754723, 33.13109],
						[116.764589, 33.114823],
						[116.764637, 33.090704],
						[116.749098, 33.075522],
						[116.748622, 33.060858],
						[116.752483, 33.053108],
						[116.781558, 33.040105],
						[116.802197, 33.032666],
						[116.814923, 33.021532],
						[116.816162, 33.013051],
						[116.810586, 32.99541],
						[116.802483, 33.000042],
						[116.79886, 32.994161],
						[116.777459, 32.996607],
						[116.778174, 33.00332],
						[116.768784, 33.000406],
						[116.76826, 33.006078],
						[116.755152, 33.002696],
						[116.754628, 32.98906],
						[116.747526, 32.978962],
						[116.740424, 32.959752],
						[116.742711, 32.94736],
						[116.735657, 32.928663]
					]
				]
			]
		},
		"properties": {
			"adcode": 340300,
			"name": "蚌埠市",
			"center": [117.363228, 32.939667],
			"centroid": [117.330324, 33.107951],
			"childrenNum": 7,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 2,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[116.771072, 31.911286],
						[116.790042, 31.922557],
						[116.810157, 31.921188],
						[116.831606, 31.935881],
						[116.841424, 31.94815],
						[116.859346, 31.960523],
						[116.865352, 31.96942],
						[116.879175, 31.974315],
						[116.921024, 31.980579],
						[116.937421, 31.989474],
						[116.929175, 31.998736],
						[116.923789, 32.013523],
						[116.940423, 32.027728],
						[116.957106, 32.022362],
						[116.96254, 32.013154],
						[116.971358, 32.016311],
						[116.985562, 32.013944],
						[116.996667, 32.006419],
						[116.996572, 31.993421],
						[117.020738, 32.001052],
						[117.029937, 32.006998],
						[117.040757, 32.024256],
						[117.046715, 32.041247],
						[117.047001, 32.051767],
						[117.030557, 32.064599],
						[117.02355, 32.074432],
						[117.020309, 32.095514],
						[117.010299, 32.115015],
						[116.997573, 32.117696],
						[116.985943, 32.128206],
						[116.978412, 32.152271],
						[116.983274, 32.161937],
						[117.007392, 32.16199],
						[117.019022, 32.168923],
						[117.024456, 32.177642],
						[117.025314, 32.190877],
						[117.004389, 32.202902],
						[117.003102, 32.212458],
						[117.013636, 32.2228],
						[117.047239, 32.225162],
						[117.059727, 32.23461],
						[117.072215, 32.266256],
						[117.067354, 32.280054],
						[117.05763, 32.284146],
						[117.046238, 32.276329],
						[117.038374, 32.281156],
						[117.035705, 32.29469],
						[117.047621, 32.320179],
						[117.057297, 32.32815],
						[117.052053, 32.33549],
						[117.043331, 32.332973],
						[117.037897, 32.342148],
						[117.043712, 32.347863],
						[117.045619, 32.381145],
						[117.042282, 32.38539],
						[117.017687, 32.383084],
						[117.00458, 32.386228],
						[117.009203, 32.404567],
						[117.026601, 32.413787],
						[117.039661, 32.415987],
						[117.048336, 32.430601],
						[117.047668, 32.438824],
						[117.06702, 32.461445],
						[117.070786, 32.469141],
						[117.068116, 32.482804],
						[117.074694, 32.491754],
						[117.079603, 32.511589],
						[117.07355, 32.51656],
						[117.084847, 32.530477],
						[117.09457, 32.531995],
						[117.110681, 32.527862],
						[117.115828, 32.521949],
						[117.127649, 32.524618],
						[117.139613, 32.520432],
						[117.150766, 32.526606],
						[117.157773, 32.535866],
						[117.167115, 32.534296],
						[117.2011, 32.534035],
						[117.203245, 32.542457],
						[117.211396, 32.54659],
						[117.214637, 32.560345],
						[117.199146, 32.579851],
						[117.195952, 32.60871],
						[117.17498, 32.653495],
						[117.172406, 32.664675],
						[117.1613, 32.679562],
						[117.162349, 32.686874],
						[117.184322, 32.696691],
						[117.189804, 32.716846],
						[117.205152, 32.728279],
						[117.195905, 32.734699],
						[117.182034, 32.735952],
						[117.179365, 32.74112],
						[117.160395, 32.739919],
						[117.15906, 32.749888],
						[117.146143, 32.751349],
						[117.125266, 32.75782],
						[117.084561, 32.744095],
						[117.081701, 32.735117],
						[117.0909, 32.727757],
						[117.074837, 32.717525],
						[117.066448, 32.723946],
						[117.046334, 32.716167],
						[117.04376, 32.721388],
						[117.054437, 32.729688],
						[117.04009, 32.732873],
						[117.033607, 32.747435],
						[117.028698, 32.747696],
						[117.029318, 32.758081],
						[117.018736, 32.757403],
						[117.001958, 32.779161],
						[116.991901, 32.783752],
						[116.960919, 32.791786],
						[116.935037, 32.808737],
						[116.921072, 32.80952],
						[116.923312, 32.816508],
						[116.897239, 32.834289],
						[116.898336, 32.842996],
						[116.889232, 32.847271],
						[116.882225, 32.8443],
						[116.834179, 32.877607],
						[116.840614, 32.88657],
						[116.836467, 32.890843],
						[116.817831, 32.894021],
						[116.804866, 32.902566],
						[116.790996, 32.905014],
						[116.78499, 32.917204],
						[116.768403, 32.921476],
						[116.761301, 32.916371],
						[116.757869, 32.923767],
						[116.735657, 32.928663],
						[116.705676, 32.936944],
						[116.684323, 32.93934],
						[116.627888, 32.941475],
						[116.446382, 32.984896],
						[116.382416, 33.004777],
						[116.376649, 32.993744],
						[116.376458, 32.969019],
						[116.371739, 32.964906],
						[116.365162, 32.946891],
						[116.365877, 32.940694],
						[116.385705, 32.921632],
						[116.393856, 32.910745],
						[116.394618, 32.891311],
						[116.394428, 32.884121],
						[116.386563, 32.86833],
						[116.389995, 32.857071],
						[116.406058, 32.85337],
						[116.421882, 32.857853],
						[116.445572, 32.843518],
						[116.439614, 32.821619],
						[116.449194, 32.8139],
						[116.442473, 32.809207],
						[116.441377, 32.800184],
						[116.448765, 32.789073],
						[116.44743, 32.760951],
						[116.442998, 32.748583],
						[116.445238, 32.732977],
						[116.45539, 32.729845],
						[116.45315, 32.71481],
						[116.444142, 32.70656],
						[116.44519, 32.697997],
						[116.460252, 32.680972],
						[116.487135, 32.677942],
						[116.489327, 32.681807],
						[116.502197, 32.681024],
						[116.506439, 32.662899],
						[116.526267, 32.657779],
						[116.535276, 32.628466],
						[116.541711, 32.622874],
						[116.537898, 32.615452],
						[116.540138, 32.60296],
						[116.555867, 32.600032],
						[116.554771, 32.585864],
						[116.601863, 32.588949],
						[116.620119, 32.583354],
						[116.628984, 32.575197],
						[116.635085, 32.55386],
						[116.613827, 32.544811],
						[116.566591, 32.544183],
						[116.523741, 32.509234],
						[116.522597, 32.486468],
						[116.509966, 32.460607],
						[116.494714, 32.465319],
						[116.490471, 32.448407],
						[116.484799, 32.439347],
						[116.480176, 32.406767],
						[116.492187, 32.395817],
						[116.485371, 32.388062],
						[116.481129, 32.375276],
						[116.48418, 32.360286],
						[116.506534, 32.344403],
						[116.519261, 32.314411],
						[116.521501, 32.292539],
						[116.52641, 32.270716],
						[116.521835, 32.261113],
						[116.527554, 32.240594],
						[116.515305, 32.223377],
						[116.501101, 32.215345],
						[116.515638, 32.202692],
						[116.517068, 32.194395],
						[116.509299, 32.18468],
						[116.515495, 32.163461],
						[116.526601, 32.151746],
						[116.530224, 32.134249],
						[116.524694, 32.116434],
						[116.533131, 32.097932],
						[116.549385, 32.078848],
						[116.544046, 32.067701],
						[116.551911, 32.042036],
						[116.546858, 32.028149],
						[116.571167, 32.020468],
						[116.586801, 32.018784],
						[116.612635, 32.000947],
						[116.667735, 31.977947],
						[116.677936, 31.976263],
						[116.681939, 31.967999],
						[116.680462, 31.957259],
						[116.680509, 31.915552],
						[116.687754, 31.903437],
						[116.70234, 31.905122],
						[116.723169, 31.916711],
						[116.748479, 31.919028],
						[116.771072, 31.911286]
					]
				]
			]
		},
		"properties": {
			"adcode": 340400,
			"name": "淮南市",
			"center": [117.018329, 32.647574],
			"centroid": [116.773391, 32.47172],
			"childrenNum": 7,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 3,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": [
				[
					[118.883701, 31.500143],
					[118.877791, 31.478766],
					[118.870498, 31.463047],
					[118.866065, 31.44489],
					[118.86964, 31.421594],
					[118.851146, 31.392518],
					[118.847381, 31.393948],
					[118.829507, 31.377527],
					[118.800241, 31.368997],
					[118.784559, 31.368573],
					[118.771261, 31.363116],
					[118.7674, 31.365871],
					[118.770355, 31.379328],
					[118.765398, 31.387963],
					[118.754626, 31.385049],
					[118.74576, 31.372706],
					[118.735036, 31.344781],
					[118.72107, 31.322679],
					[118.714731, 31.321671],
					[118.704102, 31.307782],
					[118.692186, 31.309001],
					[118.681747, 31.304336],
					[118.656866, 31.304654],
					[118.617543, 31.294103],
					[118.598001, 31.295004],
					[118.575122, 31.291345],
					[118.572548, 31.300306],
					[118.55515, 31.318862],
					[118.55129, 31.331955],
					[118.557724, 31.346371],
					[118.543663, 31.365606],
					[118.522929, 31.381924],
					[118.524979, 31.401788],
					[118.510775, 31.406289],
					[118.490946, 31.403588],
					[118.484512, 31.392465],
					[118.470403, 31.393737],
					[118.461347, 31.399722],
					[118.444998, 31.393472],
					[118.44352, 31.405389],
					[118.436371, 31.425777],
					[118.430031, 31.436155],
					[118.424598, 31.456166],
					[118.431795, 31.461512],
					[118.431747, 31.472997],
					[118.420355, 31.481465],
					[118.415255, 31.49771],
					[118.392853, 31.507868],
					[118.376552, 31.532518],
					[118.347953, 31.465058],
					[118.340089, 31.453519],
					[118.326171, 31.444149],
					[118.317305, 31.44399],
					[118.314636, 31.45336],
					[118.316781, 31.474267],
					[118.321976, 31.485487],
					[118.311204, 31.496757],
					[118.309965, 31.506598],
					[118.304054, 31.507815],
					[118.303149, 31.497233],
					[118.291948, 31.499403],
					[118.267686, 31.510195],
					[118.269831, 31.515327],
					[118.249955, 31.529291],
					[118.248239, 31.533576],
					[118.219593, 31.525483],
					[118.202434, 31.526541],
					[118.198144, 31.535004],
					[118.18537, 31.538071],
					[118.167877, 31.531724],
					[118.157153, 31.522098],
					[118.135084, 31.51702],
					[118.136657, 31.499244],
					[118.144903, 31.477337],
					[118.15067, 31.468287],
					[118.14109, 31.471568],
					[118.127696, 31.461353],
					[118.131652, 31.437267],
					[118.148096, 31.437002],
					[118.171214, 31.429484],
					[118.162682, 31.413757],
					[118.168592, 31.403376],
					[118.16516, 31.399139],
					[117.991233, 31.438537],
					[117.97965, 31.432872],
					[117.974646, 31.437584],
					[117.976076, 31.448226],
					[117.969355, 31.45569],
					[117.968354, 31.465641],
					[117.98027, 31.466805],
					[117.986895, 31.474479],
					[117.963016, 31.486545],
					[117.965399, 31.498239],
					[117.952386, 31.519823],
					[117.939565, 31.525113],
					[117.952148, 31.536961],
					[117.941662, 31.540663],
					[117.92803, 31.538441],
					[117.919784, 31.54923],
					[117.908297, 31.54685],
					[117.907248, 31.556686],
					[117.913921, 31.564987],
					[117.928268, 31.568212],
					[117.935323, 31.58053],
					[117.929603, 31.587138],
					[117.936037, 31.588935],
					[117.932129, 31.604474],
					[117.937181, 31.610446],
					[117.934608, 31.618108],
					[117.941138, 31.626932],
					[117.96273, 31.627143],
					[117.960775, 31.616681],
					[117.971929, 31.620486],
					[117.973311, 31.63845],
					[117.969021, 31.642148],
					[117.963873, 31.659368],
					[117.967639, 31.662168],
					[117.949288, 31.671357],
					[117.939183, 31.671357],
					[117.941424, 31.679067],
					[117.932272, 31.681813],
					[117.913206, 31.704042],
					[117.913063, 31.715339],
					[117.92007, 31.734129],
					[117.915256, 31.75033],
					[117.924741, 31.76141],
					[117.909441, 31.767424],
					[117.905961, 31.777553],
					[117.913445, 31.787522],
					[117.901385, 31.811782],
					[117.908011, 31.832556],
					[117.913874, 31.840885],
					[117.935751, 31.855433],
					[117.94171, 31.868873],
					[117.951862, 31.906229],
					[117.96435, 31.90154],
					[117.988373, 31.881836],
					[118.044808, 31.859545],
					[118.061776, 31.858543],
					[118.072834, 31.850901],
					[118.083988, 31.8538],
					[118.085942, 31.877462],
					[118.109107, 31.891425],
					[118.120832, 31.906123],
					[118.132034, 31.903331],
					[118.147763, 31.907967],
					[118.171118, 31.900118],
					[118.181843, 31.907651],
					[118.187277, 31.919186],
					[118.203959, 31.927719],
					[118.219736, 31.925296],
					[118.239421, 31.944096],
					[118.256724, 31.954469],
					[118.290136, 31.979895],
					[118.304865, 31.985527],
					[118.305341, 31.998],
					[118.31721, 32.019836],
					[118.334464, 32.031253],
					[118.348716, 32.035461],
					[118.358344, 32.045297],
					[118.385084, 32.05813],
					[118.394378, 32.0484],
					[118.385989, 32.033146],
					[118.401528, 32.018679],
					[118.38966, 32.012049],
					[118.390994, 31.989527],
					[118.387181, 31.983264],
					[118.376695, 31.981737],
					[118.379221, 31.967262],
					[118.369021, 31.956153],
					[118.369498, 31.944201],
					[118.36435, 31.930141],
					[118.375313, 31.925349],
					[118.386037, 31.914815],
					[118.402958, 31.914025],
					[118.415923, 31.901435],
					[118.440136, 31.892689],
					[118.452291, 31.884628],
					[118.47231, 31.879623],
					[118.467114, 31.868873],
					[118.466781, 31.858016],
					[118.475456, 31.850321],
					[118.490613, 31.843152],
					[118.504721, 31.841729],
					[118.486132, 31.795434],
					[118.482176, 31.778344],
					[118.503196, 31.778028],
					[118.510775, 31.765631],
					[118.523597, 31.76199],
					[118.533844, 31.767266],
					[118.539659, 31.761568],
					[118.538706, 31.74938],
					[118.522119, 31.743047],
					[118.530031, 31.742309],
					[118.545093, 31.732071],
					[118.550003, 31.735976],
					[118.5572, 31.729643],
					[118.57169, 31.746214],
					[118.575312, 31.740937],
					[118.593091, 31.74442],
					[118.600718, 31.75397],
					[118.609345, 31.757189],
					[118.619021, 31.750066],
					[118.627076, 31.759458],
					[118.641661, 31.758244],
					[118.648382, 31.748799],
					[118.64209, 31.744314],
					[118.6521, 31.739776],
					[118.653959, 31.730118],
					[118.677267, 31.728587],
					[118.684893, 31.724893],
					[118.687324, 31.716183],
					[118.697715, 31.709426],
					[118.680746, 31.696598],
					[118.673406, 31.696334],
					[118.671404, 31.688467],
					[118.654912, 31.675635],
					[118.647, 31.679859],
					[118.643234, 31.671357],
					[118.647953, 31.659368],
					[118.643616, 31.650019],
					[118.657867, 31.641091],
					[118.673835, 31.640563],
					[118.684798, 31.636231],
					[118.694998, 31.639718],
					[118.716923, 31.639454],
					[118.719402, 31.62746],
					[118.728649, 31.634276],
					[118.734226, 31.632216],
					[118.745141, 31.656516],
					[118.744378, 31.668347],
					[118.751146, 31.677694],
					[118.768306, 31.677483],
					[118.774121, 31.682605],
					[118.799049, 31.666393],
					[118.783082, 31.656516],
					[118.789564, 31.646532],
					[118.796046, 31.628306],
					[118.802767, 31.619482],
					[118.81454, 31.619218],
					[118.819545, 31.628517],
					[118.833844, 31.630314],
					[118.858534, 31.623973],
					[118.868735, 31.611397],
					[118.870784, 31.599347],
					[118.865303, 31.591789],
					[118.877314, 31.589675],
					[118.873358, 31.573922],
					[118.881985, 31.564775],
					[118.875122, 31.551979],
					[118.873739, 31.531936],
					[118.883939, 31.53146],
					[118.885846, 31.518871],
					[118.883701, 31.500143]
				]
			]
		},
		"properties": {
			"adcode": 340500,
			"name": "马鞍山市",
			"center": [118.507906, 31.689362],
			"centroid": [118.369758, 31.637138],
			"childrenNum": 6,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 4,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[116.393713, 33.783082],
						[116.408155, 33.770393],
						[116.406439, 33.762552],
						[116.435753, 33.762191],
						[116.433226, 33.739696],
						[116.460014, 33.734123],
						[116.463589, 33.719724],
						[116.479413, 33.708678],
						[116.478603, 33.697992],
						[116.484227, 33.697889],
						[116.492426, 33.681315],
						[116.49214, 33.668405],
						[116.485848, 33.666081],
						[116.481129, 33.654253],
						[116.503817, 33.631265],
						[116.505486, 33.618968],
						[116.533751, 33.614575],
						[116.543808, 33.59783],
						[116.551101, 33.596642],
						[116.55153, 33.588578],
						[116.540662, 33.587596],
						[116.548002, 33.57007],
						[116.531939, 33.565624],
						[116.525505, 33.551455],
						[116.52846, 33.544008],
						[116.524742, 33.53056],
						[116.534656, 33.525077],
						[116.539089, 33.513178],
						[116.533989, 33.498018],
						[116.535562, 33.481302],
						[116.547478, 33.467897],
						[116.56826, 33.466292],
						[116.58213, 33.471209],
						[116.593617, 33.480112],
						[116.612778, 33.481872],
						[116.623503, 33.485495],
						[116.63642, 33.484977],
						[116.642378, 33.477628],
						[116.665733, 33.474626],
						[116.687182, 33.47799],
						[116.700004, 33.474056],
						[116.722597, 33.450709],
						[116.745905, 33.449104],
						[116.756725, 33.438438],
						[116.7705, 33.431861],
						[116.804628, 33.422902],
						[116.796572, 33.403012],
						[116.800862, 33.386122],
						[116.790948, 33.360005],
						[116.794141, 33.354822],
						[116.787421, 33.347254],
						[116.790424, 33.334553],
						[116.789089, 33.319777],
						[116.801911, 33.303908],
						[116.807344, 33.30702],
						[116.820452, 33.302197],
						[116.841186, 33.284977],
						[116.849909, 33.281553],
						[116.869832, 33.286118],
						[116.878841, 33.299656],
						[116.904532, 33.299656],
						[116.923407, 33.30702],
						[116.929413, 33.317132],
						[116.927268, 33.324703],
						[116.918355, 33.328539],
						[116.921119, 33.334346],
						[116.913922, 33.344559],
						[116.924218, 33.34658],
						[116.928174, 33.358813],
						[116.932749, 33.360212],
						[116.942902, 33.377417],
						[116.957249, 33.374464],
						[116.958298, 33.379957],
						[116.973455, 33.391977],
						[116.964351, 33.399334],
						[116.969403, 33.412336],
						[116.965209, 33.419069],
						[116.971358, 33.42834],
						[116.96621, 33.433052],
						[116.966734, 33.443305],
						[116.958822, 33.452314],
						[116.940042, 33.453608],
						[116.929461, 33.462151],
						[116.928793, 33.470795],
						[116.904961, 33.47711],
						[116.905771, 33.482338],
						[116.919594, 33.492895],
						[116.90458, 33.505987],
						[116.915257, 33.53894],
						[116.927888, 33.543905],
						[116.928269, 33.554403],
						[116.937039, 33.580307],
						[116.915209, 33.578291],
						[116.899527, 33.572035],
						[116.873741, 33.589612],
						[116.865209, 33.603878],
						[116.859728, 33.62429],
						[116.867926, 33.637361],
						[116.871787, 33.650483],
						[116.869594, 33.661949],
						[116.873693, 33.675945],
						[116.880795, 33.676874],
						[116.906343, 33.670884],
						[116.917116, 33.674137],
						[116.929365, 33.673156],
						[116.928221, 33.702948],
						[116.939279, 33.705116],
						[116.932082, 33.739335],
						[116.93437, 33.748158],
						[116.950767, 33.746146],
						[116.943951, 33.756465],
						[116.942235, 33.773746],
						[116.95029, 33.790096],
						[116.949575, 33.808814],
						[116.951386, 33.832476],
						[116.958155, 33.847732],
						[116.959108, 33.880245],
						[116.962826, 33.892918],
						[116.986038, 33.899047],
						[116.997096, 33.914188],
						[116.990471, 33.92495],
						[116.99948, 33.938336],
						[116.991234, 33.952801],
						[116.991281, 33.961757],
						[116.98375, 33.964948],
						[116.970929, 33.961809],
						[116.95763, 33.967676],
						[116.977459, 33.993609],
						[116.974027, 33.998703],
						[116.978603, 34.007191],
						[116.969451, 34.013672],
						[116.971596, 34.025604],
						[116.967163, 34.028895],
						[116.947668, 34.031004],
						[116.950195, 34.037072],
						[116.94805, 34.05224],
						[116.961634, 34.064218],
						[116.973074, 34.07897],
						[116.955628, 34.077788],
						[116.929556, 34.080615],
						[116.92865, 34.091201],
						[116.908965, 34.098961],
						[116.902435, 34.098241],
						[116.888898, 34.082722],
						[116.874122, 34.073984],
						[116.850719, 34.082516],
						[116.845905, 34.06977],
						[116.833512, 34.066223],
						[116.828555, 34.058923],
						[116.816639, 34.072854],
						[116.818689, 34.086114],
						[116.806248, 34.077017],
						[116.811682, 34.067919],
						[116.808345, 34.063961],
						[116.801911, 34.032392],
						[116.807678, 34.012386],
						[116.803055, 33.993712],
						[116.796239, 34.003384],
						[116.784084, 34.007293],
						[116.784418, 34.011357],
						[116.752435, 34.013003],
						[116.745762, 34.017015],
						[116.734275, 34.012077],
						[116.730652, 34.016192],
						[116.711158, 34.014186],
						[116.703913, 34.009454],
						[116.689899, 34.016141],
						[116.678984, 34.010174],
						[116.662445, 34.018198],
						[116.648765, 34.021438],
						[116.626887, 34.017581],
						[116.604199, 34.021335],
						[116.60315, 34.007911],
						[116.607249, 33.999886],
						[116.629937, 33.984039],
						[116.633512, 33.977093],
						[116.64805, 33.973336],
						[116.650338, 33.959081],
						[116.639995, 33.948889],
						[116.645762, 33.929893],
						[116.638517, 33.917175],
						[116.642712, 33.892454],
						[116.627316, 33.888591],
						[116.611825, 33.894617],
						[116.597097, 33.904146],
						[116.581606, 33.908317],
						[116.567068, 33.908214],
						[116.558346, 33.901674],
						[116.555104, 33.888282],
						[116.558393, 33.881482],
						[116.546668, 33.882512],
						[116.53928, 33.874218],
						[116.536897, 33.882255],
						[116.525219, 33.880503],
						[116.521215, 33.871075],
						[116.505295, 33.872363],
						[116.501911, 33.864686],
						[116.484895, 33.869787],
						[116.47398, 33.861337],
						[116.460157, 33.859946],
						[116.453007, 33.846959],
						[116.437326, 33.846547],
						[116.432988, 33.814846],
						[116.436944, 33.80309],
						[116.432607, 33.795304],
						[116.420929, 33.796696],
						[116.40825, 33.805514],
						[116.393713, 33.783082]
					]
				],
				[
					[
						[117.031558, 34.166709],
						[117.025314, 34.167633],
						[117.030795, 34.18632],
						[117.040328, 34.201513],
						[117.047239, 34.205772],
						[117.051005, 34.221577],
						[117.044904, 34.224758],
						[117.049575, 34.242406],
						[117.042092, 34.248664],
						[117.031081, 34.242765],
						[117.035085, 34.23189],
						[117.030175, 34.221372],
						[117.021691, 34.213675],
						[117.009584, 34.219679],
						[117.007821, 34.232967],
						[116.994666, 34.222808],
						[116.988803, 34.205208],
						[116.99538, 34.206337],
						[116.980271, 34.195867],
						[116.982416, 34.172357],
						[116.993522, 34.168352],
						[116.980176, 34.155978],
						[116.982416, 34.167274],
						[116.975457, 34.169071],
						[116.971501, 34.154643],
						[116.982177, 34.137285],
						[117.001768, 34.142318],
						[117.004913, 34.151408],
						[117.012921, 34.149508],
						[117.023312, 34.161678],
						[117.031748, 34.155721],
						[117.031558, 34.166709]
					]
				]
			]
		},
		"properties": {
			"adcode": 340600,
			"name": "淮北市",
			"center": [116.794664, 33.971707],
			"centroid": [116.74441, 33.720047],
			"childrenNum": 4,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 5,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[117.156248, 31.072411],
						[117.149908, 31.058272],
						[117.144141, 31.054179],
						[117.14395, 31.039293],
						[117.137611, 31.028925],
						[117.141186, 31.014514],
						[117.134799, 31.007281],
						[117.124599, 31.006749],
						[117.111348, 31.01345],
						[117.093903, 31.0101],
						[117.095142, 30.988558],
						[117.082654, 30.974885],
						[117.080366, 30.961743],
						[117.086419, 30.92864],
						[117.096477, 30.885728],
						[117.106248, 30.827558],
						[117.105009, 30.790677],
						[117.101005, 30.767379],
						[117.117211, 30.755968],
						[117.124694, 30.740343],
						[117.162969, 30.708604],
						[117.178078, 30.702148],
						[117.187277, 30.70663],
						[117.190566, 30.698467],
						[117.200337, 30.701881],
						[117.205009, 30.69201],
						[117.241376, 30.690356],
						[117.223979, 30.686514],
						[117.212968, 30.678616],
						[117.207296, 30.669543],
						[117.205485, 30.654384],
						[117.211872, 30.635111],
						[117.217068, 30.630626],
						[117.272644, 30.656626],
						[117.309489, 30.676801],
						[117.343426, 30.688969],
						[117.366829, 30.694251],
						[117.394379, 30.694998],
						[117.399384, 30.690676],
						[117.422358, 30.682885],
						[117.4511, 30.679043],
						[117.470404, 30.678989],
						[117.485418, 30.686514],
						[117.493616, 30.696706],
						[117.507249, 30.726688],
						[117.576934, 30.756662],
						[117.645523, 30.776603],
						[117.670594, 30.781508],
						[117.701815, 30.806614],
						[117.698526, 30.789931],
						[117.72088, 30.791103],
						[117.742568, 30.8072],
						[117.751529, 30.802936],
						[117.755961, 30.792223],
						[117.748478, 30.778522],
						[117.759918, 30.769832],
						[117.758202, 30.761674],
						[117.781938, 30.764127],
						[117.78375, 30.749729],
						[117.796238, 30.748449],
						[117.803101, 30.757462],
						[117.815733, 30.759914],
						[117.842282, 30.773617],
						[117.846333, 30.788438],
						[117.872787, 30.807893],
						[117.884036, 30.812317],
						[117.903197, 30.814022],
						[117.915828, 30.819564],
						[117.934608, 30.835763],
						[117.94333, 30.833099],
						[117.953626, 30.817593],
						[117.980413, 30.843808],
						[117.993473, 30.854623],
						[118.013397, 30.862347],
						[118.024217, 30.845673],
						[118.041566, 30.843276],
						[118.048144, 30.855156],
						[118.039612, 30.857553],
						[118.056914, 30.872254],
						[118.079412, 30.866608],
						[118.099097, 30.885515],
						[118.134369, 30.902075],
						[118.1572, 30.901383],
						[118.164779, 30.907186],
						[118.154579, 30.923211],
						[118.152911, 30.932207],
						[118.160346, 30.952697],
						[118.159059, 30.963925],
						[118.143807, 30.970682],
						[118.124836, 30.967862],
						[118.105198, 30.970948],
						[118.097572, 30.985579],
						[118.083654, 30.993824],
						[118.070975, 31.011376],
						[118.03251, 31.017173],
						[118.025933, 31.030414],
						[118.013778, 31.034508],
						[118.009679, 31.045407],
						[118.021881, 31.064704],
						[118.005818, 31.078204],
						[117.985513, 31.079745],
						[117.973311, 31.084316],
						[117.95863, 31.074643],
						[117.935466, 31.067681],
						[117.923788, 31.068318],
						[117.897954, 31.07831],
						[117.890423, 31.086016],
						[117.88027, 31.122039],
						[117.869879, 31.133141],
						[117.850718, 31.140205],
						[117.831938, 31.139143],
						[117.807391, 31.129742],
						[117.781319, 31.111468],
						[117.767496, 31.096113],
						[117.752339, 31.057688],
						[117.731414, 31.00994],
						[117.721023, 31.0101],
						[117.718306, 31.019087],
						[117.70763, 31.01127],
						[117.697525, 31.0101],
						[117.700432, 31.002494],
						[117.693759, 30.98893],
						[117.686181, 30.98526],
						[117.683082, 30.968767],
						[117.665828, 30.966639],
						[117.66721, 30.956049],
						[117.66049, 30.940031],
						[117.65129, 30.950409],
						[117.650671, 30.957646],
						[117.62641, 30.972119],
						[117.592568, 30.978131],
						[117.583512, 30.970735],
						[117.568926, 30.968607],
						[117.560966, 30.974194],
						[117.54905, 30.967596],
						[117.532892, 30.973662],
						[117.536943, 30.992015],
						[117.523168, 30.994569],
						[117.507534, 31.003452],
						[117.494808, 30.996005],
						[117.45925, 30.988983],
						[117.44824, 30.982706],
						[117.441567, 30.967916],
						[117.412968, 30.97728],
						[117.385466, 30.964829],
						[117.383273, 30.951899],
						[117.371453, 30.950994],
						[117.365161, 30.959029],
						[117.369498, 30.963659],
						[117.356534, 30.987919],
						[117.348907, 30.992122],
						[117.337802, 30.987653],
						[117.324789, 30.989249],
						[117.314065, 30.999835],
						[117.306343, 30.999994],
						[117.298002, 30.985526],
						[117.28518, 30.98244],
						[117.277315, 30.984728],
						[117.247049, 31.011217],
						[117.229365, 31.022331],
						[117.225409, 31.03706],
						[117.212063, 31.057315],
						[117.190566, 31.0697],
						[117.175314, 31.087451],
						[117.156248, 31.072411]
					]
				],
				[
					[
						[117.297144, 30.487209],
						[117.290137, 30.4763],
						[117.274456, 30.465229],
						[117.256724, 30.458543],
						[117.25558, 30.45405],
						[117.267211, 30.441746],
						[117.259203, 30.430511],
						[117.25253, 30.428798],
						[117.251958, 30.420558],
						[117.268545, 30.420184],
						[117.281129, 30.414458],
						[117.299289, 30.425374],
						[117.293378, 30.440997],
						[117.305437, 30.445812],
						[117.31478, 30.461859],
						[117.321882, 30.462234],
						[117.326648, 30.470631],
						[117.324551, 30.487637],
						[117.319784, 30.49277],
						[117.307535, 30.494267],
						[117.297144, 30.487209]
					]
				],
				[
					[
						[116.960728, 30.628544],
						[116.97703, 30.643547],
						[116.967354, 30.657053],
						[116.956963, 30.658013],
						[116.951434, 30.656145],
						[116.934465, 30.661323],
						[116.92212, 30.654277],
						[116.920643, 30.646163],
						[116.934656, 30.632121],
						[116.960728, 30.628544]
					]
				]
			]
		},
		"properties": {
			"adcode": 340700,
			"name": "铜陵市",
			"center": [117.816576, 30.929935],
			"centroid": [117.566978, 30.888245],
			"cp": [117.566978, 30.86],
			"childrenNum": 4,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 6,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": [
				[
					[116.903341, 30.357289],
					[116.910347, 30.332869],
					[116.9205, 30.314283],
					[116.928793, 30.290978],
					[116.927173, 30.273455],
					[116.920547, 30.257966],
					[116.892711, 30.240492],
					[116.867497, 30.213576],
					[116.860061, 30.17732],
					[116.841901, 30.146739],
					[116.816925, 30.115075],
					[116.771787, 30.073681],
					[116.747335, 30.057248],
					[116.720309, 30.053918],
					[116.685705, 30.07062],
					[116.666877, 30.076742],
					[116.642616, 30.076366],
					[116.611015, 30.070728],
					[116.596572, 30.059718],
					[116.586039, 30.046291],
					[116.57131, 30.014433],
					[116.571215, 29.98923],
					[116.564542, 29.949343],
					[116.558727, 29.924338],
					[116.551959, 29.90987],
					[116.54152, 29.901641],
					[116.525552, 29.897498],
					[116.479842, 29.897875],
					[116.467736, 29.896154],
					[116.441758, 29.879852],
					[116.392521, 29.855745],
					[116.35968, 29.843635],
					[116.343093, 29.835669],
					[116.322788, 29.820004],
					[116.312302, 29.808967],
					[116.280796, 29.788882],
					[116.261444, 29.782042],
					[116.253627, 29.783119],
					[116.227364, 29.816881],
					[116.208108, 29.827487],
					[116.187326, 29.829048],
					[116.167354, 29.827379],
					[116.135181, 29.819412],
					[116.131987, 29.844281],
					[116.134561, 29.877431],
					[116.125791, 29.901372],
					[116.104056, 29.926866],
					[116.085705, 29.950795],
					[116.077936, 29.956117],
					[116.073837, 29.969987],
					[116.081463, 29.981759],
					[116.078317, 30.010242],
					[116.088994, 30.026952],
					[116.091663, 30.036192],
					[116.079986, 30.057248],
					[116.079223, 30.066217],
					[116.0848, 30.075937],
					[116.083751, 30.095642],
					[116.088375, 30.11019],
					[116.085038, 30.126185],
					[116.075029, 30.133538],
					[116.06316, 30.151622],
					[116.056725, 30.169917],
					[116.05601, 30.181022],
					[116.063923, 30.193573],
					[116.064352, 30.206873],
					[116.046096, 30.223925],
					[116.031702, 30.227035],
					[116.026601, 30.239741],
					[116.012254, 30.249497],
					[115.994809, 30.255018],
					[115.988899, 30.267078],
					[115.985324, 30.291031],
					[115.980939, 30.295746],
					[115.958394, 30.305336],
					[115.938708, 30.306944],
					[115.921883, 30.301265],
					[115.904438, 30.310051],
					[115.903723, 30.315783],
					[115.914352, 30.3243],
					[115.916687, 30.334422],
					[115.896478, 30.3567],
					[115.884895, 30.379561],
					[115.90091, 30.397867],
					[115.909252, 30.398831],
					[115.921501, 30.416384],
					[115.930987, 30.420505],
					[115.938184, 30.417776],
					[115.946144, 30.425213],
					[115.920786, 30.429868],
					[115.915543, 30.443993],
					[115.894809, 30.452712],
					[115.894047, 30.459559],
					[115.900815, 30.469722],
					[115.898098, 30.482236],
					[115.909728, 30.506725],
					[115.919881, 30.515011],
					[115.905153, 30.52458],
					[115.899481, 30.537889],
					[115.887803, 30.542485],
					[115.883132, 30.559425],
					[115.875553, 30.569363],
					[115.87908, 30.578285],
					[115.866211, 30.587901],
					[115.857298, 30.589503],
					[115.84848, 30.601895],
					[115.828079, 30.606168],
					[115.824123, 30.596127],
					[115.819166, 30.59789],
					[115.807822, 30.615568],
					[115.814924, 30.624806],
					[115.809919, 30.642586],
					[115.798766, 30.65006],
					[115.797002, 30.658601],
					[115.775362, 30.668849],
					[115.77236, 30.677869],
					[115.762541, 30.685607],
					[115.767402, 30.694358],
					[115.765544, 30.707537],
					[115.776363, 30.728875],
					[115.782893, 30.751702],
					[115.79276, 30.759275],
					[115.810491, 30.759434],
					[115.820119, 30.750689],
					[115.834657, 30.756395],
					[115.85153, 30.756715],
					[115.854342, 30.767433],
					[115.868356, 30.774257],
					[115.8695, 30.782467],
					[115.85868, 30.784813],
					[115.865877, 30.798246],
					[115.86378, 30.815781],
					[115.848813, 30.82857],
					[115.849481, 30.841251],
					[115.863875, 30.855262],
					[115.865686, 30.864264],
					[115.876935, 30.869005],
					[115.885705, 30.877846],
					[115.912779, 30.887592],
					[115.932369, 30.889402],
					[115.936134, 30.902874],
					[115.970548, 30.920017],
					[115.976268, 30.931461],
					[115.993427, 30.936731],
					[116.009871, 30.949717],
					[116.024743, 30.953602],
					[116.034514, 30.951154],
					[116.039519, 30.957859],
					[116.07174, 30.956688],
					[116.06969, 30.969139],
					[116.0603, 30.994941],
					[116.058918, 31.012759],
					[116.046144, 31.014514],
					[116.051578, 31.042217],
					[116.050958, 31.049554],
					[116.066354, 31.070072],
					[116.092664, 31.082668],
					[116.093379, 31.090108],
					[116.10458, 31.094465],
					[116.11888, 31.086866],
					[116.157679, 31.099301],
					[116.166258, 31.0976],
					[116.18132, 31.083359],
					[116.183751, 31.064917],
					[116.203293, 31.0579],
					[116.222455, 31.061781],
					[116.243427, 31.0756],
					[116.261396, 31.082403],
					[116.268498, 31.100098],
					[116.293045, 31.114761],
					[116.303532, 31.123155],
					[116.309776, 31.140418],
					[116.3307, 31.145622],
					[116.342712, 31.15242],
					[116.344952, 31.163624],
					[116.359537, 31.173978],
					[116.378984, 31.165377],
					[116.395572, 31.162084],
					[116.415305, 31.162191],
					[116.431892, 31.144135],
					[116.437707, 31.128414],
					[116.4603, 31.125917],
					[116.470071, 31.135637],
					[116.481844, 31.136965],
					[116.496715, 31.148756],
					[116.501911, 31.141427],
					[116.508298, 31.142489],
					[116.519547, 31.160173],
					[116.538469, 31.174456],
					[116.543474, 31.181941],
					[116.552816, 31.179712],
					[116.556582, 31.172173],
					[116.552816, 31.165908],
					[116.558346, 31.147587],
					[116.555867, 31.123314],
					[116.562683, 31.111096],
					[116.549385, 31.093243],
					[116.538708, 31.072145],
					[116.533512, 31.056624],
					[116.534799, 31.044185],
					[116.530939, 31.035306],
					[116.530605, 31.021002],
					[116.543617, 31.020311],
					[116.560347, 31.034614],
					[116.563779, 31.045567],
					[116.571072, 31.051787],
					[116.591711, 31.04764],
					[116.594571, 31.054126],
					[116.611539, 31.067309],
					[116.614018, 31.073899],
					[116.622502, 31.074112],
					[116.647049, 31.05891],
					[116.65396, 31.052212],
					[116.665495, 31.059123],
					[116.68356, 31.055774],
					[116.68866, 31.048703],
					[116.70968, 31.043228],
					[116.722883, 31.059601],
					[116.736753, 31.063907],
					[116.752721, 31.060877],
					[116.761301, 31.068372],
					[116.777602, 31.070019],
					[116.78866, 31.065289],
					[116.805962, 31.08219],
					[116.815638, 31.085378],
					[116.829365, 31.101213],
					[116.843331, 31.104455],
					[116.842187, 31.11338],
					[116.847144, 31.124642],
					[116.862254, 31.129901],
					[116.875981, 31.127458],
					[116.894952, 31.133407],
					[116.919356, 31.151305],
					[116.92274, 31.160067],
					[116.943903, 31.161766],
					[116.946906, 31.182738],
					[116.954008, 31.189161],
					[116.963255, 31.214532],
					[116.981415, 31.244564],
					[116.998193, 31.2565],
					[117.006725, 31.267693],
					[117.016257, 31.266844],
					[117.032273, 31.256607],
					[117.042235, 31.252469],
					[117.055104, 31.235386],
					[117.071358, 31.236871],
					[117.079174, 31.221643],
					[117.100147, 31.190488],
					[117.109394, 31.169571],
					[117.12212, 31.148543],
					[117.121977, 31.129264],
					[117.117163, 31.12443],
					[117.122787, 31.101798],
					[117.117306, 31.08506],
					[117.13599, 31.073155],
					[117.156248, 31.072411],
					[117.149908, 31.058272],
					[117.144141, 31.054179],
					[117.14395, 31.039293],
					[117.137611, 31.028925],
					[117.141186, 31.014514],
					[117.134799, 31.007281],
					[117.124599, 31.006749],
					[117.111348, 31.01345],
					[117.093903, 31.0101],
					[117.095142, 30.988558],
					[117.082654, 30.974885],
					[117.080366, 30.961743],
					[117.086419, 30.92864],
					[117.096477, 30.885728],
					[117.106248, 30.827558],
					[117.105009, 30.790677],
					[117.101005, 30.767379],
					[117.117211, 30.755968],
					[117.124694, 30.740343],
					[117.162969, 30.708604],
					[117.178078, 30.702148],
					[117.187277, 30.70663],
					[117.190566, 30.698467],
					[117.200337, 30.701881],
					[117.205009, 30.69201],
					[117.241376, 30.690356],
					[117.223979, 30.686514],
					[117.212968, 30.678616],
					[117.207296, 30.669543],
					[117.205485, 30.654384],
					[117.211872, 30.635111],
					[117.217068, 30.630626],
					[117.21783, 30.620641],
					[117.247906, 30.58929],
					[117.252244, 30.563967],
					[117.243807, 30.538156],
					[117.241281, 30.523083],
					[117.236372, 30.504747],
					[117.226315, 30.489027],
					[117.213397, 30.476941],
					[117.192187, 30.465871],
					[117.164017, 30.474802],
					[117.135133, 30.492075],
					[117.111586, 30.495337],
					[117.025457, 30.494267],
					[117.01049, 30.489294],
					[116.986372, 30.470791],
					[116.975552, 30.458062],
					[116.950433, 30.442816],
					[116.935609, 30.440301],
					[116.914446, 30.425481],
					[116.9011, 30.436503],
					[116.892425, 30.431099],
					[116.891949, 30.414725],
					[116.888279, 30.407019],
					[116.893855, 30.381595],
					[116.903341, 30.357289]
				],
				[
					[116.956963, 30.658013],
					[116.951434, 30.656145],
					[116.934465, 30.661323],
					[116.92212, 30.654277],
					[116.920643, 30.646163],
					[116.934656, 30.632121],
					[116.960728, 30.628544],
					[116.97703, 30.643547],
					[116.967354, 30.657053],
					[116.956963, 30.658013]
				]
			]
		},
		"properties": {
			"adcode": 340800,
			"name": "安庆市",
			"center": [117.043551, 30.50883],
			"centroid": [116.451502, 30.574825],
			"childrenNum": 10,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 7,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[118.868878, 30.10144],
						[118.85005, 30.110458],
						[118.82107, 30.102728],
						[118.789945, 30.078299],
						[118.767972, 30.076796],
						[118.754626, 30.080608],
						[118.743139, 30.092743],
						[118.730365, 30.070298],
						[118.69781, 30.056818],
						[118.694807, 30.036675],
						[118.688754, 30.028993],
						[118.669021, 30.023675],
						[118.651004, 30.024534],
						[118.628029, 30.016529],
						[118.614493, 30.001805],
						[118.618592, 29.997399],
						[118.614016, 29.980469],
						[118.605818, 29.971654],
						[118.583463, 29.968321],
						[118.574931, 29.963751],
						[118.564588, 29.947569],
						[118.548668, 29.945203],
						[118.524741, 29.967407],
						[118.520784, 29.975201],
						[118.524502, 29.992508],
						[118.520403, 29.99885],
						[118.509297, 29.998312],
						[118.50577, 29.99138],
						[118.498716, 30.005997],
						[118.498096, 30.018141],
						[118.513492, 30.030659],
						[118.514016, 30.038932],
						[118.494474, 30.072124],
						[118.477696, 30.076527],
						[118.468926, 30.082434],
						[118.449955, 30.102621],
						[118.417734, 30.097306],
						[118.404483, 30.099615],
						[118.394807, 30.106271],
						[118.384607, 30.097145],
						[118.370642, 30.099722],
						[118.355103, 30.111908],
						[118.356962, 30.121945],
						[118.347477, 30.134289],
						[118.339326, 30.16584],
						[118.326647, 30.175282],
						[118.31149, 30.193197],
						[118.290708, 30.199526],
						[118.289946, 30.219046],
						[118.286562, 30.232879],
						[118.271881, 30.238186],
						[118.267782, 30.243333],
						[118.266638, 30.259842],
						[118.271404, 30.269865],
						[118.292472, 30.283691],
						[118.304912, 30.284387],
						[118.320546, 30.293764],
						[118.31211, 30.292907],
						[118.294903, 30.302122],
						[118.307629, 30.309301],
						[118.310203, 30.32055],
						[118.302052, 30.329709],
						[118.299765, 30.340796],
						[118.305532, 30.351399],
						[118.295141, 30.358306],
						[118.300289, 30.370139],
						[118.280365, 30.372387],
						[118.278173, 30.38031],
						[118.265684, 30.376402],
						[118.255913, 30.378437],
						[118.250337, 30.394816],
						[118.237801, 30.40049],
						[118.221452, 30.414351],
						[118.222977, 30.423929],
						[118.215399, 30.438322],
						[118.228077, 30.439713],
						[118.231604, 30.445651],
						[118.225217, 30.455013],
						[118.213873, 30.461271],
						[118.21373, 30.466833],
						[118.196571, 30.468652],
						[118.185847, 30.46448],
						[118.188039, 30.474481],
						[118.16864, 30.453033],
						[118.181128, 30.447844],
						[118.163254, 30.446775],
						[118.15782, 30.434309],
						[118.142901, 30.433828],
						[118.130175, 30.429601],
						[118.125027, 30.423662],
						[118.107582, 30.42928],
						[118.109774, 30.452712],
						[118.103435, 30.465229],
						[118.118211, 30.483252],
						[118.121118, 30.493091],
						[118.130747, 30.49817],
						[118.117591, 30.509238],
						[118.089612, 30.51731],
						[118.075218, 30.515011],
						[118.053721, 30.503677],
						[118.034941, 30.498438],
						[118.016924, 30.500576],
						[117.985751, 30.498705],
						[117.970118, 30.512231],
						[117.963635, 30.508436],
						[117.951481, 30.489134],
						[117.945904, 30.466726],
						[117.945904, 30.455066],
						[117.938564, 30.425106],
						[117.941233, 30.413602],
						[117.952911, 30.403594],
						[117.953197, 30.392568],
						[117.938278, 30.378115],
						[117.91659, 30.366552],
						[117.928125, 30.357289],
						[117.940137, 30.33469],
						[117.925361, 30.33078],
						[117.932034, 30.326335],
						[117.928507, 30.319747],
						[117.920356, 30.320014],
						[117.907677, 30.309783],
						[117.91292, 30.299283],
						[117.902196, 30.294246],
						[117.886419, 30.293228],
						[117.888516, 30.269597],
						[117.863206, 30.266435],
						[117.842997, 30.260378],
						[117.824932, 30.241617],
						[117.829317, 30.225212],
						[117.858345, 30.21733],
						[117.8613, 30.209072],
						[117.852863, 30.191749],
						[117.846953, 30.192286],
						[117.831366, 30.182202],
						[117.820404, 30.182577],
						[117.797811, 30.163694],
						[117.778125, 30.156719],
						[117.743187, 30.154037],
						[117.698955, 30.143466],
						[117.682606, 30.132733],
						[117.68661, 30.126132],
						[117.673264, 30.122106],
						[117.676219, 30.107936],
						[117.662491, 30.108902],
						[117.655866, 30.115451],
						[117.646143, 30.114484],
						[117.642901, 30.105627],
						[117.631176, 30.099293],
						[117.615351, 30.111693],
						[117.61049, 30.131499],
						[117.599765, 30.129781],
						[117.584846, 30.118027],
						[117.572739, 30.115719],
						[117.568736, 30.107399],
						[117.560299, 30.103748],
						[117.571071, 30.101762],
						[117.56845, 30.088233],
						[117.559965, 30.0834],
						[117.554293, 30.101601],
						[117.545618, 30.101601],
						[117.541043, 30.11062],
						[117.528983, 30.099561],
						[117.535371, 30.083776],
						[117.544093, 30.086783],
						[117.53599, 30.076581],
						[117.542091, 30.052844],
						[117.511491, 30.037105],
						[117.492806, 30.034903],
						[117.461777, 30.037965],
						[117.446476, 30.02303],
						[117.433273, 30.02072],
						[117.411538, 30.030444],
						[117.394093, 30.029745],
						[117.386372, 30.011048],
						[117.349813, 30.008254],
						[117.324217, 29.99799],
						[117.309155, 29.999065],
						[117.297668, 29.992777],
						[117.267401, 29.98321],
						[117.260156, 29.985253],
						[117.206152, 29.974288],
						[117.203102, 29.965149],
						[117.206248, 29.927511],
						[117.21702, 29.92692],
						[117.246238, 29.915088],
						[117.253722, 29.90901],
						[117.261777, 29.880659],
						[117.25682, 29.859512],
						[117.249336, 29.846111],
						[117.257392, 29.831255],
						[117.271214, 29.830071],
						[117.278173, 29.825118],
						[117.292425, 29.822803],
						[117.297239, 29.836853],
						[117.303007, 29.840352],
						[117.325695, 29.843851],
						[117.333273, 29.850578],
						[117.338612, 29.847887],
						[117.347906, 29.822319],
						[117.356248, 29.813705],
						[117.375981, 29.818066],
						[117.384084, 29.843635],
						[117.403292, 29.84891],
						[117.418783, 29.850417],
						[117.424789, 29.834646],
						[117.409155, 29.802613],
						[117.413588, 29.78802],
						[117.434703, 29.761143],
						[117.44314, 29.758935],
						[117.455104, 29.749184],
						[117.457249, 29.725315],
						[117.451862, 29.695942],
						[117.474217, 29.668339],
						[117.493759, 29.65955],
						[117.516543, 29.663379],
						[117.530556, 29.65405],
						[117.523454, 29.629619],
						[117.534274, 29.598545],
						[117.54333, 29.588563],
						[117.546238, 29.594337],
						[117.557963, 29.590128],
						[117.574074, 29.591099],
						[117.586467, 29.584732],
						[117.608726, 29.591585],
						[117.628316, 29.606207],
						[117.647954, 29.614893],
						[117.661443, 29.611818],
						[117.668974, 29.596981],
						[117.678983, 29.59547],
						[117.682225, 29.587268],
						[117.682987, 29.568002],
						[117.69047, 29.555912],
						[117.707677, 29.549002],
						[117.736038, 29.551539],
						[117.753054, 29.560392],
						[117.770928, 29.557099],
						[117.794951, 29.570323],
						[117.807296, 29.573561],
						[117.822787, 29.571834],
						[117.829889, 29.563846],
						[117.852005, 29.554994],
						[117.863588, 29.55413],
						[117.876505, 29.546195],
						[117.889851, 29.545817],
						[117.920785, 29.554508],
						[117.938707, 29.549596],
						[117.954913, 29.565087],
						[117.964874, 29.569999],
						[117.984703, 29.561633],
						[117.994665, 29.573183],
						[118.003864, 29.578094],
						[118.014112, 29.577285],
						[118.042949, 29.566275],
						[118.050718, 29.543172],
						[118.082653, 29.533778],
						[118.103435, 29.530647],
						[118.109536, 29.521954],
						[118.13456, 29.508778],
						[118.142996, 29.499867],
						[118.143807, 29.489767],
						[118.127648, 29.472049],
						[118.137992, 29.454868],
						[118.138611, 29.437684],
						[118.12946, 29.432604],
						[118.136085, 29.418876],
						[118.163635, 29.412066],
						[118.1766, 29.404714],
						[118.188135, 29.406119],
						[118.193044, 29.395253],
						[118.204245, 29.395415],
						[118.218115, 29.42039],
						[118.232939, 29.423903],
						[118.248525, 29.431307],
						[118.255723, 29.426173],
						[118.267782, 29.427848],
						[118.276266, 29.423417],
						[118.28618, 29.426713],
						[118.291376, 29.419957],
						[118.316113, 29.422606],
						[118.316018, 29.450545],
						[118.306581, 29.47945],
						[118.310537, 29.496032],
						[118.324407, 29.49695],
						[118.34762, 29.473994],
						[118.358725, 29.477073],
						[118.379793, 29.502567],
						[118.38394, 29.510398],
						[118.393044, 29.50732],
						[118.414969, 29.50975],
						[118.429507, 29.503647],
						[118.448954, 29.513422],
						[118.458249, 29.506348],
						[118.47903, 29.510938],
						[118.495904, 29.519578],
						[118.497858, 29.543982],
						[118.494903, 29.553698],
						[118.500575, 29.575666],
						[118.535227, 29.590614],
						[118.549907, 29.613382],
						[118.555055, 29.613382],
						[118.573883, 29.638357],
						[118.602052, 29.643696],
						[118.619974, 29.654104],
						[118.633511, 29.648765],
						[118.640946, 29.641916],
						[118.647333, 29.643372],
						[118.67393, 29.669094],
						[118.682319, 29.686454],
						[118.700813, 29.706452],
						[118.718687, 29.709201],
						[118.724645, 29.72262],
						[118.744712, 29.738786],
						[118.749049, 29.761143],
						[118.74433, 29.779618],
						[118.736513, 29.788451],
						[118.739945, 29.813274],
						[118.745999, 29.818173],
						[118.75944, 29.817151],
						[118.765922, 29.823073],
						[118.750956, 29.831632],
						[118.755627, 29.845412],
						[118.766923, 29.848964],
						[118.778744, 29.841913],
						[118.802624, 29.860642],
						[118.807724, 29.867638],
						[118.841328, 29.891312],
						[118.845522, 29.899112],
						[118.844902, 29.915249],
						[118.838706, 29.934502],
						[118.848287, 29.941278],
						[118.86392, 29.936976],
						[118.871976, 29.94687],
						[118.884702, 29.938912],
						[118.894664, 29.938051],
						[118.891566, 29.959881],
						[118.899478, 29.981437],
						[118.89209, 29.994819],
						[118.895093, 30.001214],
						[118.890327, 30.012015],
						[118.898048, 30.017227],
						[118.902576, 30.029047],
						[118.890565, 30.041242],
						[118.897333, 30.051877],
						[118.888134, 30.06235],
						[118.878839, 30.064659],
						[118.875455, 30.072017],
						[118.872929, 30.094622],
						[118.868878, 30.10144]
					]
				]
			]
		},
		"properties": {
			"adcode": 341000,
			"name": "黄山市",
			"center": [118.317325, 29.709239],
			"centroid": [118.076088, 29.904836],
			"childrenNum": 7,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 8,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[117.951862, 31.906229],
						[117.96435, 31.90154],
						[117.988373, 31.881836],
						[118.044808, 31.859545],
						[118.061776, 31.858543],
						[118.072834, 31.850901],
						[118.083988, 31.8538],
						[118.085942, 31.877462],
						[118.109107, 31.891425],
						[118.120832, 31.906123],
						[118.132034, 31.903331],
						[118.147763, 31.907967],
						[118.171118, 31.900118],
						[118.181843, 31.907651],
						[118.187277, 31.919186],
						[118.203959, 31.927719],
						[118.219736, 31.925296],
						[118.239421, 31.944096],
						[118.256724, 31.954469],
						[118.290136, 31.979895],
						[118.304865, 31.985527],
						[118.305341, 31.998],
						[118.31721, 32.019836],
						[118.334464, 32.031253],
						[118.348716, 32.035461],
						[118.358344, 32.045297],
						[118.385084, 32.05813],
						[118.393282, 32.062705],
						[118.39476, 32.075589],
						[118.405198, 32.075799],
						[118.415112, 32.087418],
						[118.433511, 32.086682],
						[118.44109, 32.092045],
						[118.463349, 32.100666],
						[118.472977, 32.114858],
						[118.489469, 32.120744],
						[118.499097, 32.120376],
						[118.495046, 32.132883],
						[118.500622, 32.141711],
						[118.507438, 32.137875],
						[118.495618, 32.165194],
						[118.496809, 32.178588],
						[118.506485, 32.182107],
						[118.509822, 32.19429],
						[118.524645, 32.189039],
						[118.532367, 32.195813],
						[118.539612, 32.192452],
						[118.551719, 32.199646],
						[118.561728, 32.196863],
						[118.574931, 32.202587],
						[118.580889, 32.198649],
						[118.598334, 32.199489],
						[118.61964, 32.205475],
						[118.626599, 32.202534],
						[118.64414, 32.20999],
						[118.667495, 32.235923],
						[118.675741, 32.255131],
						[118.667448, 32.257545],
						[118.659249, 32.266098],
						[118.670784, 32.285615],
						[118.667305, 32.296369],
						[118.659964, 32.296369],
						[118.66025, 32.305443],
						[118.678458, 32.316561],
						[118.694855, 32.317243],
						[118.683463, 32.325003],
						[118.687657, 32.329985],
						[118.703244, 32.328988],
						[118.707915, 32.338426],
						[118.697524, 32.34262],
						[118.69986, 32.34975],
						[118.692901, 32.35169],
						[118.702052, 32.357927],
						[118.696094, 32.367991],
						[118.698763, 32.383189],
						[118.690184, 32.378263],
						[118.678697, 32.393931],
						[118.685751, 32.404986],
						[118.68904, 32.420649],
						[118.686895, 32.429815],
						[118.692615, 32.46511],
						[118.689278, 32.473486],
						[118.675217, 32.470136],
						[118.647715, 32.476522],
						[118.643425, 32.470502],
						[118.628077, 32.467675],
						[118.608582, 32.470554],
						[118.608058, 32.475842],
						[118.59333, 32.478826],
						[118.592376, 32.499867],
						[118.60801, 32.501751],
						[118.617448, 32.512426],
						[118.614445, 32.520432],
						[118.604864, 32.522839],
						[118.608821, 32.537069],
						[118.599002, 32.544654],
						[118.584655, 32.548996],
						[118.56373, 32.564372],
						[118.569497, 32.586439],
						[118.581271, 32.594543],
						[118.598096, 32.601339],
						[118.601814, 32.597366],
						[118.623406, 32.592609],
						[118.633034, 32.578962],
						[118.65229, 32.593079],
						[118.668782, 32.594909],
						[118.689564, 32.588531],
						[118.68904, 32.604737],
						[118.696666, 32.588269],
						[118.700861, 32.588531],
						[118.698001, 32.60641],
						[118.725312, 32.608239],
						[118.726027, 32.59632],
						[118.740708, 32.589367],
						[118.74433, 32.598882],
						[118.757533, 32.603953],
						[118.775789, 32.597732],
						[118.774693, 32.588112],
						[118.784369, 32.58257],
						[118.801766, 32.584348],
						[118.81373, 32.600816],
						[118.824931, 32.601914],
						[118.824645, 32.589628],
						[118.819259, 32.58623],
						[118.827791, 32.579694],
						[118.827028, 32.572687],
						[118.848525, 32.56819],
						[118.85596, 32.574361],
						[118.872405, 32.576034],
						[118.887896, 32.587119],
						[118.907867, 32.592295],
						[118.909345, 32.586857],
						[118.89638, 32.577289],
						[118.898668, 32.56045],
						[118.888325, 32.557207],
						[118.91597, 32.549519],
						[118.916351, 32.556057],
						[118.936561, 32.557521],
						[118.940565, 32.547793],
						[118.964778, 32.52671],
						[118.967924, 32.514572],
						[118.97984, 32.503844],
						[118.997428, 32.503896],
						[119.007533, 32.514048],
						[119.021737, 32.517868],
						[119.041375, 32.514781],
						[119.045522, 32.498454],
						[119.064445, 32.482385],
						[119.067447, 32.462439],
						[119.073691, 32.455371],
						[119.085131, 32.452701],
						[119.095998, 32.466052],
						[119.12045, 32.480082],
						[119.134511, 32.491545],
						[119.147762, 32.492644],
						[119.142281, 32.499396],
						[119.150098, 32.50981],
						[119.155579, 32.528071],
						[119.167781, 32.536337],
						[119.166685, 32.546014],
						[119.154483, 32.554958],
						[119.153863, 32.561862],
						[119.175169, 32.571066],
						[119.176933, 32.593811],
						[119.187133, 32.59998],
						[119.19433, 32.578596],
						[119.209297, 32.573576],
						[119.220212, 32.576609],
						[119.220069, 32.592452],
						[119.230984, 32.607141],
						[119.220498, 32.60986],
						[119.216923, 32.617282],
						[119.220212, 32.629616],
						[119.208677, 32.642784],
						[119.211632, 32.708179],
						[119.208963, 32.71528],
						[119.2082, 32.740493],
						[119.200908, 32.750984],
						[119.19128, 32.788812],
						[119.188896, 32.810876],
						[119.18494, 32.825634],
						[119.113062, 32.822922],
						[119.104292, 32.826729],
						[119.071308, 32.864733],
						[119.054912, 32.875053],
						[119.045712, 32.892458],
						[119.044997, 32.911422],
						[119.019497, 32.905118],
						[119.015064, 32.911683],
						[119.019831, 32.925695],
						[119.029602, 32.92632],
						[119.023549, 32.935382],
						[119.026313, 32.947255],
						[119.020832, 32.955795],
						[119.008916, 32.959388],
						[118.993663, 32.958242],
						[118.961203, 32.945797],
						[118.941613, 32.94611],
						[118.933796, 32.938663],
						[118.921451, 32.939548],
						[118.90577, 32.945068],
						[118.893568, 32.940798],
						[118.891232, 32.951734],
						[118.896237, 32.957774],
						[118.884654, 32.960585],
						[118.865255, 32.955014],
						[118.849335, 32.956628],
						[118.849383, 32.945902],
						[118.842519, 32.943662],
						[118.848954, 32.927205],
						[118.839516, 32.922517],
						[118.836942, 32.911422],
						[118.819021, 32.920642],
						[118.812205, 32.916892],
						[118.809345, 32.90788],
						[118.814588, 32.902722],
						[118.811251, 32.87547],
						[118.806199, 32.870258],
						[118.812538, 32.865203],
						[118.811728, 32.854986],
						[118.791042, 32.848418],
						[118.768163, 32.851494],
						[118.747858, 32.858687],
						[118.741804, 32.85337],
						[118.746809, 32.800392],
						[118.736847, 32.79335],
						[118.737943, 32.773265],
						[118.746332, 32.759281],
						[118.751528, 32.757142],
						[118.757438, 32.743834],
						[118.756294, 32.737048],
						[118.736704, 32.732351],
						[118.724454, 32.72191],
						[118.707248, 32.720292],
						[118.69414, 32.726608],
						[118.657581, 32.736109],
						[118.654054, 32.740702],
						[118.639421, 32.744825],
						[118.632319, 32.739971],
						[118.617019, 32.73898],
						[118.607534, 32.726661],
						[118.590803, 32.724834],
						[118.576599, 32.719091],
						[118.559726, 32.729897],
						[118.545284, 32.72948],
						[118.520451, 32.723215],
						[118.489755, 32.72452],
						[118.483511, 32.721388],
						[118.45925, 32.726086],
						[118.450479, 32.743364],
						[118.422882, 32.718099],
						[118.410966, 32.716063],
						[118.398668, 32.721388],
						[118.375313, 32.718987],
						[118.368163, 32.724781],
						[118.366256, 32.73496],
						[118.37231, 32.741746],
						[118.371166, 32.757716],
						[118.366209, 32.768309],
						[118.348811, 32.773004],
						[118.334035, 32.761577],
						[118.326409, 32.763456],
						[118.320785, 32.778274],
						[118.307153, 32.778691],
						[118.298764, 32.785578],
						[118.294426, 32.800131],
						[118.306628, 32.810563],
						[118.297858, 32.832047],
						[118.301719, 32.846228],
						[118.289517, 32.845499],
						[118.284607, 32.85728],
						[118.263206, 32.856185],
						[118.250575, 32.848366],
						[118.244426, 32.87448],
						[118.240041, 32.882349],
						[118.233034, 32.916267],
						[118.235418, 32.926528],
						[118.247906, 32.934757],
						[118.293378, 32.947151],
						[118.309631, 32.958971],
						[118.303816, 32.968655],
						[118.269355, 32.969175],
						[118.252434, 32.982137],
						[118.244807, 32.998324],
						[118.243473, 33.027776],
						[118.239612, 33.046451],
						[118.233368, 33.060025],
						[118.212396, 33.06195],
						[118.21516, 33.070946],
						[118.227648, 33.06949],
						[118.223692, 33.083477],
						[118.202863, 33.088104],
						[118.206485, 33.091276],
						[118.221309, 33.087637],
						[118.22088, 33.105883],
						[118.209679, 33.104324],
						[118.210441, 33.111861],
						[118.219593, 33.114096],
						[118.22374, 33.155457],
						[118.221261, 33.182208],
						[118.211633, 33.199085],
						[118.194379, 33.211701],
						[118.178173, 33.217983],
						[118.168354, 33.213466],
						[118.156342, 33.19545],
						[118.159965, 33.181065],
						[118.14905, 33.169483],
						[118.118878, 33.160548],
						[118.088278, 33.149691],
						[118.070451, 33.140391],
						[118.067925, 33.135143],
						[118.050337, 33.133792],
						[118.044617, 33.127192],
						[118.05129, 33.124854],
						[118.073835, 33.135143],
						[118.07455, 33.117318],
						[118.065017, 33.09741],
						[118.072691, 33.081034],
						[118.061681, 33.07469],
						[118.032749, 33.073962],
						[118.018116, 33.06143],
						[118.004341, 33.055293],
						[117.99843, 33.040625],
						[118.005151, 33.031417],
						[118.018306, 33.034539],
						[118.0368, 33.027099],
						[118.031462, 33.014716],
						[118.011347, 33.001759],
						[118.003721, 33.002227],
						[117.982796, 33.01175],
						[117.970642, 33.001967],
						[117.947858, 33.014508],
						[117.937706, 33.008576],
						[117.913492, 32.987655],
						[117.899384, 32.990257],
						[117.879698, 33.002748],
						[117.895237, 33.013884],
						[117.89762, 33.019607],
						[117.890613, 33.031781],
						[117.893711, 33.035059],
						[117.886752, 33.046607],
						[117.880222, 33.041977],
						[117.860346, 33.035995],
						[117.822406, 33.02814],
						[117.800146, 33.031209],
						[117.787515, 33.045202],
						[117.773359, 33.047335],
						[117.762587, 33.040833],
						[117.746333, 33.009825],
						[117.737039, 33.001083],
						[117.718545, 33.006391],
						[117.707963, 33.00254],
						[117.698287, 32.985],
						[117.694665, 32.96928],
						[117.679174, 32.943871],
						[117.671834, 32.918819],
						[117.657534, 32.910745],
						[117.64619, 32.912308],
						[117.626886, 32.924809],
						[117.603483, 32.922257],
						[117.589994, 32.933924],
						[117.576839, 32.941059],
						[117.56864, 32.951369],
						[117.548526, 32.969592],
						[117.531224, 32.980576],
						[117.528173, 32.967041],
						[117.528602, 32.938976],
						[117.512396, 32.93283],
						[117.505151, 32.908557],
						[117.49967, 32.897408],
						[117.512253, 32.886153],
						[117.513588, 32.875261],
						[117.508249, 32.868747],
						[117.491281, 32.864681],
						[117.479222, 32.842944],
						[117.471167, 32.837157],
						[117.457773, 32.841484],
						[117.432272, 32.842266],
						[117.422168, 32.846593],
						[117.415113, 32.831995],
						[117.395857, 32.836427],
						[117.368354, 32.837783],
						[117.361729, 32.840129],
						[117.350814, 32.829232],
						[117.325218, 32.825894],
						[117.314017, 32.828241],
						[117.307678, 32.818959],
						[117.284942, 32.817447],
						[117.280366, 32.808842],
						[117.265542, 32.800862],
						[117.255819, 32.80566],
						[117.244665, 32.794602],
						[117.231796, 32.77217],
						[117.214112, 32.752027],
						[117.202673, 32.745399],
						[117.195905, 32.734699],
						[117.205152, 32.728279],
						[117.189804, 32.716846],
						[117.184322, 32.696691],
						[117.162349, 32.686874],
						[117.1613, 32.679562],
						[117.172406, 32.664675],
						[117.17498, 32.653495],
						[117.195952, 32.60871],
						[117.199146, 32.579851],
						[117.214637, 32.560345],
						[117.211396, 32.54659],
						[117.203245, 32.542457],
						[117.2011, 32.534035],
						[117.211205, 32.516194],
						[117.209632, 32.493953],
						[117.211586, 32.476261],
						[117.209012, 32.472544],
						[117.219546, 32.463015],
						[117.244951, 32.460136],
						[117.266877, 32.451444],
						[117.28294, 32.442751],
						[117.293045, 32.443799],
						[117.30844, 32.451234],
						[117.32722, 32.441704],
						[117.365113, 32.455895],
						[117.380938, 32.464377],
						[117.394046, 32.478302],
						[117.408297, 32.468565],
						[117.39376, 32.452805],
						[117.38232, 32.43102],
						[117.382415, 32.409177],
						[117.377315, 32.398385],
						[117.359251, 32.384971],
						[117.369546, 32.382508],
						[117.392568, 32.388115],
						[117.405342, 32.375119],
						[117.44171, 32.366524],
						[117.444903, 32.343512],
						[117.423359, 32.334546],
						[117.412587, 32.319602],
						[117.395761, 32.283727],
						[117.40825, 32.26762],
						[117.425218, 32.259539],
						[117.427268, 32.242536],
						[117.435371, 32.236762],
						[117.449098, 32.233928],
						[117.46864, 32.223482],
						[117.48232, 32.212405],
						[117.498145, 32.203532],
						[117.553864, 32.215975],
						[117.576076, 32.230726],
						[117.59395, 32.239124],
						[117.605437, 32.238914],
						[117.613921, 32.250198],
						[117.622549, 32.249988],
						[117.631986, 32.256915],
						[117.631748, 32.248886],
						[117.652434, 32.260799],
						[117.672215, 32.261061],
						[117.673216, 32.250985],
						[117.697239, 32.248781],
						[117.707487, 32.243901],
						[117.712015, 32.236553],
						[117.729126, 32.245632],
						[117.741281, 32.247154],
						[117.757439, 32.240646],
						[117.770928, 32.239177],
						[117.781605, 32.231986],
						[117.791471, 32.219755],
						[117.807391, 32.221225],
						[117.819879, 32.230516],
						[117.833225, 32.221697],
						[117.847191, 32.217445],
						[117.863921, 32.195498],
						[117.872739, 32.141028],
						[117.855342, 32.123319],
						[117.851624, 32.105975],
						[117.867019, 32.106553],
						[117.868163, 32.097354],
						[117.858059, 32.093832],
						[117.866495, 32.085841],
						[117.868259, 32.075957],
						[117.885084, 32.064125],
						[117.864207, 32.047086],
						[117.842377, 32.041773],
						[117.833416, 32.03383],
						[117.832987, 32.015259],
						[117.810918, 32.002262],
						[117.82946, 31.994789],
						[117.836085, 31.979053],
						[117.844665, 31.974526],
						[117.846428, 31.962576],
						[117.865637, 31.954311],
						[117.868592, 31.945307],
						[117.868116, 31.928982],
						[117.886562, 31.926771],
						[117.900051, 31.92914],
						[117.91516, 31.922189],
						[117.929698, 31.920819],
						[117.951862, 31.906229]
					]
				]
			]
		},
		"properties": {
			"adcode": 341100,
			"name": "滁州市",
			"center": [118.316264, 32.303627],
			"centroid": [118.107896, 32.543514],
			"childrenNum": 8,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 9,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": [
				[
					[115.508632, 32.468565],
					[115.496716, 32.493377],
					[115.490377, 32.496308],
					[115.486993, 32.510542],
					[115.477651, 32.511798],
					[115.47665, 32.520955],
					[115.465734, 32.520118],
					[115.438947, 32.53257],
					[115.443713, 32.543294],
					[115.434657, 32.545177],
					[115.431082, 32.552448],
					[115.408871, 32.54999],
					[115.412779, 32.559822],
					[115.411588, 32.574779],
					[115.403246, 32.576661],
					[115.38766, 32.570909],
					[115.328985, 32.561182],
					[115.324695, 32.555952],
					[115.305105, 32.55318],
					[115.297145, 32.560555],
					[115.300387, 32.568399],
					[115.310873, 32.570543],
					[115.29848, 32.573263],
					[115.305534, 32.583197],
					[115.299386, 32.588112],
					[115.294858, 32.581054],
					[115.289185, 32.58989],
					[115.267212, 32.578073],
					[115.254724, 32.584975],
					[115.261302, 32.591667],
					[115.254772, 32.595223],
					[115.241998, 32.592609],
					[115.229796, 32.579067],
					[115.223647, 32.581472],
					[115.22951, 32.59057],
					[115.21216, 32.588478],
					[115.201102, 32.591824],
					[115.192236, 32.602332],
					[115.209634, 32.611689],
					[115.199386, 32.619686],
					[115.201054, 32.633378],
					[115.194572, 32.631288],
					[115.194905, 32.642366],
					[115.202722, 32.645501],
					[115.209538, 32.636723],
					[115.208919, 32.64989],
					[115.219405, 32.65919],
					[115.204009, 32.653913],
					[115.205153, 32.672928],
					[115.193666, 32.682852],
					[115.189472, 32.678778],
					[115.196907, 32.672719],
					[115.182989, 32.666764],
					[115.18461, 32.678308],
					[115.178461, 32.682904],
					[115.182703, 32.694498],
					[115.179081, 32.701965],
					[115.184324, 32.720396],
					[115.179367, 32.726347],
					[115.189615, 32.770917],
					[115.183561, 32.776917],
					[115.182084, 32.787299],
					[115.191092, 32.790064],
					[115.209491, 32.785421],
					[115.206345, 32.79768],
					[115.196907, 32.802114],
					[115.189948, 32.812545],
					[115.195573, 32.828867],
					[115.1889, 32.840389],
					[115.202675, 32.843518],
					[115.198575, 32.854361],
					[115.19114, 32.857488],
					[115.176269, 32.856289],
					[115.159777, 32.862284],
					[115.154915, 32.877294],
					[115.141998, 32.885423],
					[115.14052, 32.897512],
					[115.116164, 32.900221],
					[115.098099, 32.894802],
					[115.08623, 32.903243],
					[115.067355, 32.903243],
					[115.029748, 32.906838],
					[115.02746, 32.914339],
					[115.036755, 32.916319],
					[115.03542, 32.932361],
					[115.023981, 32.933715],
					[115.009252, 32.940173],
					[114.978795, 32.941319],
					[114.959967, 32.939496],
					[114.951817, 32.934393],
					[114.942236, 32.937569],
					[114.93604, 32.95215],
					[114.924124, 32.958971],
					[114.914543, 32.971622],
					[114.893857, 32.972663],
					[114.883371, 32.983751],
					[114.884944, 32.992703],
					[114.901579, 33.000354],
					[114.891903, 33.020492],
					[114.915401, 33.016069],
					[114.924934, 33.016746],
					[114.936993, 33.025486],
					[114.92298, 33.036099],
					[114.922456, 33.048323],
					[114.914972, 33.059765],
					[114.919548, 33.068814],
					[114.914019, 33.082801],
					[114.897289, 33.086597],
					[114.898242, 33.096942],
					[114.906297, 33.11659],
					[114.902913, 33.129583],
					[114.910253, 33.136598],
					[114.92665, 33.13852],
					[114.933085, 33.144911],
					[114.932656, 33.154003],
					[114.958061, 33.150003],
					[114.966354, 33.146366],
					[114.968881, 33.133688],
					[114.981464, 33.129063],
					[114.992332, 33.120956],
					[114.990473, 33.102868],
					[115.012017, 33.09767],
					[115.023361, 33.090756],
					[115.041235, 33.086649],
					[115.051578, 33.092472],
					[115.057441, 33.083737],
					[115.069548, 33.086753],
					[115.111111, 33.082905],
					[115.153247, 33.084413],
					[115.167927, 33.088728],
					[115.172408, 33.108066],
					[115.197146, 33.121424],
					[115.209824, 33.113472],
					[115.224362, 33.126257],
					[115.236993, 33.126724],
					[115.246288, 33.13639],
					[115.266497, 33.1327],
					[115.269595, 33.137845],
					[115.290329, 33.132441],
					[115.292856, 33.143404],
					[115.301483, 33.141638],
					[115.300148, 33.16299],
					[115.294381, 33.177897],
					[115.296764, 33.201317],
					[115.326411, 33.211338],
					[115.316259, 33.218398],
					[115.316307, 33.223797],
					[115.33175, 33.235631],
					[115.330511, 33.251979],
					[115.340139, 33.261164],
					[115.340854, 33.271748],
					[115.333799, 33.284717],
					[115.335039, 33.2981],
					[115.347002, 33.301004],
					[115.360205, 33.2981],
					[115.358776, 33.311428],
					[115.36502, 33.336005],
					[115.348337, 33.33896],
					[115.346812, 33.358709],
					[115.338566, 33.363011],
					[115.341664, 33.371199],
					[115.316116, 33.370992],
					[115.313256, 33.377107],
					[115.329414, 33.401665],
					[115.317355, 33.418241],
					[115.315639, 33.431447],
					[115.319023, 33.441493],
					[115.316354, 33.448897],
					[115.323313, 33.448638],
					[115.324552, 33.457595],
					[115.335944, 33.447292],
					[115.345811, 33.449777],
					[115.348861, 33.478973],
					[115.343809, 33.480837],
					[115.351245, 33.490411],
					[115.345429, 33.502934],
					[115.366592, 33.523473],
					[115.395096, 33.506504],
					[115.396812, 33.502002],
					[115.405344, 33.516696],
					[115.401721, 33.524353],
					[115.414638, 33.541629],
					[115.421979, 33.556782],
					[115.463685, 33.567227],
					[115.474314, 33.55735],
					[115.501864, 33.564383],
					[115.511302, 33.553369],
					[115.528556, 33.562728],
					[115.552722, 33.56552],
					[115.559347, 33.561953],
					[115.565019, 33.576378],
					[115.601149, 33.578187],
					[115.639757, 33.585115],
					[115.651244, 33.544629],
					[115.676697, 33.508729],
					[115.681273, 33.505831],
					[115.698337, 33.509557],
					[115.720834, 33.51085],
					[115.749481, 33.499881],
					[115.751387, 33.495896],
					[115.769404, 33.490515],
					[115.773217, 33.484718],
					[115.786135, 33.481044],
					[115.796049, 33.468569],
					[115.807441, 33.466861],
					[115.831606, 33.451227],
					[115.848861, 33.450864],
					[115.854962, 33.442321],
					[115.897383, 33.400525],
					[115.895334, 33.384724],
					[115.898432, 33.356999],
					[115.911111, 33.340567],
					[115.914399, 33.328902],
					[115.921406, 33.323303],
					[115.919833, 33.313606],
					[115.92603, 33.309769],
					[115.927841, 33.298722],
					[115.914828, 33.295506],
					[115.915972, 33.279478],
					[115.906725, 33.255975],
					[115.909204, 33.246634],
					[115.917498, 33.24269],
					[115.925696, 33.229195],
					[115.916497, 33.215491],
					[115.876983, 33.248295],
					[115.839423, 33.262824],
					[115.832083, 33.256753],
					[115.8297, 33.231635],
					[115.835277, 33.21383],
					[115.845238, 33.193528],
					[115.841378, 33.180234],
					[115.825505, 33.162678],
					[115.824361, 33.150938],
					[115.831034, 33.157172],
					[115.850196, 33.153535],
					[115.850196, 33.136078],
					[115.839709, 33.135454],
					[115.844333, 33.125321],
					[115.865925, 33.125581],
					[115.877126, 33.122151],
					[115.872026, 33.103128],
					[115.866735, 33.094343],
					[115.89848, 33.093667],
					[115.914876, 33.088],
					[115.948098, 33.080774],
					[115.980796, 33.07079],
					[116.002483, 33.060077],
					[116.018213, 33.056125],
					[116.010157, 33.043954],
					[116.01602, 33.041925],
					[116.04214, 33.048843],
					[116.051053, 33.044266],
					[116.0552, 33.034227],
					[116.051768, 33.021428],
					[116.059013, 33.016954],
					[116.060062, 33.003737],
					[116.052531, 32.99515],
					[116.054914, 32.99057],
					[116.083084, 32.986458],
					[116.125743, 32.976047],
					[116.155581, 32.973757],
					[116.167926, 32.967145],
					[116.165305, 32.959492],
					[116.168165, 32.940642],
					[116.178889, 32.922882],
					[116.191711, 32.91387],
					[116.198432, 32.893396],
					[116.212636, 32.888706],
					[116.232988, 32.889852],
					[116.245333, 32.884954],
					[116.248527, 32.872812],
					[116.280319, 32.859052],
					[116.292569, 32.858948],
					[116.30825, 32.86562],
					[116.348098, 32.878128],
					[116.370881, 32.900221],
					[116.386992, 32.89772],
					[116.394618, 32.891311],
					[116.394428, 32.884121],
					[116.386563, 32.86833],
					[116.389995, 32.857071],
					[116.406058, 32.85337],
					[116.421882, 32.857853],
					[116.445572, 32.843518],
					[116.439614, 32.821619],
					[116.449194, 32.8139],
					[116.442473, 32.809207],
					[116.441377, 32.800184],
					[116.448765, 32.789073],
					[116.44743, 32.760951],
					[116.442998, 32.748583],
					[116.445238, 32.732977],
					[116.45539, 32.729845],
					[116.45315, 32.71481],
					[116.444142, 32.70656],
					[116.44519, 32.697997],
					[116.460252, 32.680972],
					[116.487135, 32.677942],
					[116.489327, 32.681807],
					[116.502197, 32.681024],
					[116.506439, 32.662899],
					[116.526267, 32.657779],
					[116.535276, 32.628466],
					[116.541711, 32.622874],
					[116.537898, 32.615452],
					[116.540138, 32.60296],
					[116.555867, 32.600032],
					[116.554771, 32.585864],
					[116.601863, 32.588949],
					[116.620119, 32.583354],
					[116.628984, 32.575197],
					[116.635085, 32.55386],
					[116.613827, 32.544811],
					[116.566591, 32.544183],
					[116.523741, 32.509234],
					[116.522597, 32.486468],
					[116.509966, 32.460607],
					[116.494714, 32.465319],
					[116.490471, 32.448407],
					[116.484799, 32.439347],
					[116.472359, 32.438247],
					[116.437564, 32.45092],
					[116.404819, 32.442804],
					[116.392235, 32.447621],
					[116.358489, 32.464743],
					[116.332798, 32.510385],
					[116.320071, 32.521164],
					[116.271692, 32.520955],
					[116.26397, 32.494738],
					[116.246334, 32.48406],
					[116.251244, 32.464429],
					[116.244523, 32.4549],
					[116.23561, 32.465843],
					[116.222979, 32.459193],
					[116.213065, 32.463748],
					[116.203722, 32.447621],
					[116.191187, 32.454271],
					[116.176411, 32.425363],
					[116.167879, 32.439766],
					[116.148146, 32.439923],
					[116.141854, 32.46045],
					[116.124552, 32.47113],
					[116.113398, 32.490812],
					[116.101435, 32.523833],
					[116.090948, 32.539162],
					[116.076411, 32.543974],
					[116.05663, 32.546328],
					[116.036849, 32.555011],
					[116.03113, 32.573524],
					[116.022026, 32.591563],
					[115.996954, 32.602907],
					[115.967355, 32.605103],
					[115.95234, 32.59104],
					[115.936992, 32.571955],
					[115.928365, 32.567563],
					[115.915448, 32.576871],
					[115.891568, 32.576243],
					[115.887564, 32.567667],
					[115.861397, 32.537383],
					[115.845953, 32.531628],
					[115.839948, 32.524775],
					[115.841473, 32.501227],
					[115.823837, 32.502222],
					[115.804104, 32.485473],
					[115.788756, 32.468931],
					[115.780987, 32.46757],
					[115.78704, 32.485788],
					[115.771502, 32.505309],
					[115.766783, 32.492435],
					[115.757202, 32.480187],
					[115.74195, 32.476365],
					[115.701197, 32.495313],
					[115.692093, 32.487515],
					[115.692188, 32.480605],
					[115.701244, 32.470869],
					[115.696716, 32.467466],
					[115.675887, 32.466419],
					[115.681559, 32.451182],
					[115.680606, 32.439976],
					[115.674933, 32.431963],
					[115.66745, 32.40991],
					[115.656297, 32.408758],
					[115.657965, 32.427406],
					[115.654152, 32.428925],
					[115.645572, 32.417559],
					[115.627126, 32.405457],
					[115.604533, 32.42594],
					[115.586087, 32.419235],
					[115.563875, 32.402995],
					[115.553628, 32.407501],
					[115.569119, 32.414625],
					[115.567593, 32.421644],
					[115.547288, 32.424735],
					[115.537469, 32.438928],
					[115.523218, 32.442018],
					[115.524123, 32.447831],
					[115.515591, 32.450606],
					[115.509347, 32.466733],
					[115.508632, 32.468565]
				]
			]
		},
		"properties": {
			"adcode": 341200,
			"name": "阜阳市",
			"center": [115.819729, 32.896969],
			"centroid": [115.709049, 32.916536],
			"cp": [115.75, 32.85],
			"childrenNum": 8,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 10,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[116.604199, 34.021335],
						[116.626887, 34.017581],
						[116.648765, 34.021438],
						[116.662445, 34.018198],
						[116.678984, 34.010174],
						[116.689899, 34.016141],
						[116.703913, 34.009454],
						[116.711158, 34.014186],
						[116.730652, 34.016192],
						[116.734275, 34.012077],
						[116.745762, 34.017015],
						[116.752435, 34.013003],
						[116.784418, 34.011357],
						[116.784084, 34.007293],
						[116.796239, 34.003384],
						[116.803055, 33.993712],
						[116.807678, 34.012386],
						[116.801911, 34.032392],
						[116.808345, 34.063961],
						[116.811682, 34.067919],
						[116.806248, 34.077017],
						[116.818689, 34.086114],
						[116.816639, 34.072854],
						[116.828555, 34.058923],
						[116.833512, 34.066223],
						[116.845905, 34.06977],
						[116.850719, 34.082516],
						[116.874122, 34.073984],
						[116.888898, 34.082722],
						[116.902435, 34.098241],
						[116.908965, 34.098961],
						[116.92865, 34.091201],
						[116.929556, 34.080615],
						[116.955628, 34.077788],
						[116.973074, 34.07897],
						[116.961634, 34.064218],
						[116.94805, 34.05224],
						[116.950195, 34.037072],
						[116.947668, 34.031004],
						[116.967163, 34.028895],
						[116.971596, 34.025604],
						[116.969451, 34.013672],
						[116.978603, 34.007191],
						[116.974027, 33.998703],
						[116.977459, 33.993609],
						[116.95763, 33.967676],
						[116.970929, 33.961809],
						[116.98375, 33.964948],
						[116.991281, 33.961757],
						[116.991234, 33.952801],
						[116.99948, 33.938336],
						[116.990471, 33.92495],
						[116.997096, 33.914188],
						[116.986038, 33.899047],
						[116.962826, 33.892918],
						[116.959108, 33.880245],
						[116.958155, 33.847732],
						[116.951386, 33.832476],
						[116.949575, 33.808814],
						[116.95029, 33.790096],
						[116.942235, 33.773746],
						[116.943951, 33.756465],
						[116.950767, 33.746146],
						[116.93437, 33.748158],
						[116.932082, 33.739335],
						[116.939279, 33.705116],
						[116.928221, 33.702948],
						[116.929365, 33.673156],
						[116.917116, 33.674137],
						[116.906343, 33.670884],
						[116.880795, 33.676874],
						[116.873693, 33.675945],
						[116.869594, 33.661949],
						[116.871787, 33.650483],
						[116.867926, 33.637361],
						[116.859728, 33.62429],
						[116.865209, 33.603878],
						[116.873741, 33.589612],
						[116.899527, 33.572035],
						[116.915209, 33.578291],
						[116.937039, 33.580307],
						[116.928269, 33.554403],
						[116.927888, 33.543905],
						[116.915257, 33.53894],
						[116.90458, 33.505987],
						[116.919594, 33.492895],
						[116.905771, 33.482338],
						[116.904961, 33.47711],
						[116.928793, 33.470795],
						[116.929461, 33.462151],
						[116.940042, 33.453608],
						[116.958822, 33.452314],
						[116.966734, 33.443305],
						[116.96621, 33.433052],
						[116.971358, 33.42834],
						[116.965209, 33.419069],
						[116.969403, 33.412336],
						[116.964351, 33.399334],
						[116.973455, 33.391977],
						[116.958298, 33.379957],
						[116.957249, 33.374464],
						[116.942902, 33.377417],
						[116.932749, 33.360212],
						[116.928174, 33.358813],
						[116.924218, 33.34658],
						[116.913922, 33.344559],
						[116.921119, 33.334346],
						[116.918355, 33.328539],
						[116.927268, 33.324703],
						[116.929413, 33.317132],
						[116.923407, 33.30702],
						[116.937897, 33.301315],
						[116.953531, 33.286637],
						[116.974599, 33.278389],
						[116.986658, 33.281657],
						[117.002578, 33.278025],
						[117.012444, 33.279219],
						[117.025409, 33.29644],
						[117.034132, 33.293276],
						[117.095523, 33.284873],
						[117.099289, 33.307746],
						[117.092092, 33.316147],
						[117.065018, 33.321591],
						[117.064303, 33.332842],
						[117.074932, 33.333931],
						[117.080795, 33.344507],
						[117.093521, 33.346788],
						[117.096572, 33.353941],
						[117.084894, 33.365498],
						[117.062873, 33.373946],
						[117.051243, 33.371406],
						[117.060728, 33.392288],
						[117.08232, 33.406638],
						[117.094808, 33.398246],
						[117.108774, 33.398194],
						[117.107344, 33.392702],
						[117.125504, 33.380993],
						[117.133417, 33.387366],
						[117.14376, 33.409694],
						[117.134656, 33.419743],
						[117.126839, 33.422384],
						[117.128793, 33.434554],
						[117.139708, 33.442011],
						[117.154818, 33.439059],
						[117.15968, 33.457543],
						[117.202721, 33.423472],
						[117.208011, 33.453091],
						[117.231367, 33.47328],
						[117.241996, 33.489945],
						[117.24314, 33.501537],
						[117.261967, 33.497035],
						[117.309632, 33.490877],
						[117.320404, 33.476127],
						[117.34519, 33.475661],
						[117.365399, 33.470951],
						[117.391519, 33.456249],
						[117.40172, 33.424766],
						[117.424169, 33.399955],
						[117.433607, 33.379024],
						[117.477077, 33.347772],
						[117.484274, 33.345544],
						[117.507344, 33.346062],
						[117.528793, 33.339686],
						[117.539756, 33.327813],
						[117.56416, 33.333257],
						[117.577982, 33.32548],
						[117.58966, 33.323303],
						[117.609393, 33.339789],
						[117.62374, 33.345336],
						[117.631939, 33.343677],
						[117.642997, 33.333465],
						[117.66783, 33.327917],
						[117.677124, 33.309924],
						[117.690184, 33.304997],
						[117.692663, 33.291668],
						[117.710585, 33.282954],
						[117.728125, 33.284821],
						[117.737801, 33.275068],
						[117.775408, 33.282383],
						[117.793283, 33.277559],
						[117.808345, 33.283161],
						[117.809536, 33.296232],
						[117.824836, 33.299085],
						[117.846619, 33.295247],
						[117.85353, 33.304323],
						[117.859202, 33.324962],
						[117.870976, 33.329213],
						[117.894379, 33.330613],
						[117.897954, 33.340308],
						[117.909155, 33.344455],
						[117.916018, 33.330095],
						[117.952148, 33.32885],
						[117.972691, 33.330095],
						[117.978983, 33.334139],
						[117.969546, 33.34404],
						[117.971595, 33.349328],
						[117.995475, 33.347099],
						[118.005913, 33.352075],
						[118.029269, 33.372236],
						[118.02598, 33.381459],
						[118.028268, 33.390578],
						[118.016924, 33.407001],
						[118.021881, 33.421193],
						[118.023597, 33.440923],
						[118.028649, 33.458423],
						[118.043568, 33.473694],
						[118.05067, 33.492067],
						[118.061681, 33.490773],
						[118.108106, 33.475091],
						[118.106819, 33.503917],
						[118.107963, 33.520163],
						[118.099145, 33.529371],
						[118.108392, 33.529991],
						[118.117782, 33.594419],
						[118.112443, 33.617262],
						[118.120117, 33.621655],
						[118.168258, 33.664015],
						[118.163969, 33.692623],
						[118.167734, 33.714975],
						[118.153339, 33.720137],
						[118.160823, 33.73531],
						[118.177458, 33.735826],
						[118.185322, 33.744959],
						[118.16292, 33.750738],
						[118.148859, 33.746404],
						[118.129746, 33.754195],
						[118.117973, 33.766524],
						[118.105961, 33.764616],
						[118.065589, 33.765802],
						[118.062443, 33.758374],
						[118.045761, 33.750016],
						[118.028316, 33.746662],
						[118.03089, 33.74047],
						[118.019974, 33.738716],
						[118.018783, 33.745836],
						[117.996714, 33.746146],
						[117.994426, 33.750067],
						[117.982796, 33.747333],
						[117.972358, 33.750274],
						[117.964922, 33.763429],
						[117.954293, 33.751047],
						[117.949431, 33.734071],
						[117.936705, 33.729375],
						[117.920547, 33.733349],
						[117.915828, 33.738354],
						[117.90048, 33.735671],
						[117.897572, 33.729324],
						[117.901671, 33.720137],
						[117.887706, 33.722614],
						[117.879936, 33.727775],
						[117.858964, 33.734329],
						[117.835847, 33.734123],
						[117.825504, 33.737322],
						[117.791757, 33.7334],
						[117.777935, 33.722511],
						[117.767067, 33.72184],
						[117.752673, 33.711517],
						[117.735275, 33.722717],
						[117.731939, 33.734742],
						[117.722739, 33.740831],
						[117.724694, 33.749551],
						[117.734036, 33.75177],
						[117.741853, 33.762759],
						[117.749002, 33.791643],
						[117.752482, 33.812835],
						[117.746142, 33.823765],
						[117.750099, 33.827167],
						[117.752959, 33.847165],
						[117.752434, 33.863243],
						[117.759203, 33.874527],
						[117.758631, 33.885655],
						[117.753769, 33.891424],
						[117.740852, 33.89199],
						[117.715399, 33.879267],
						[117.703626, 33.887818],
						[117.690089, 33.915372],
						[117.672596, 33.934938],
						[117.672501, 33.95239],
						[117.662968, 33.968705],
						[117.671309, 33.986715],
						[117.666305, 33.998703],
						[117.64252, 34.01542],
						[117.629746, 34.02869],
						[117.6164, 34.032289],
						[117.610251, 34.029307],
						[117.618116, 34.017118],
						[117.616638, 34.004927],
						[117.610299, 33.999217],
						[117.597859, 33.997005],
						[117.588183, 33.987847],
						[117.575742, 33.982908],
						[117.568926, 33.985223],
						[117.556438, 34.007345],
						[117.544665, 34.01362],
						[117.54252, 34.021644],
						[117.545332, 34.035169],
						[117.537468, 34.04463],
						[117.514779, 34.060877],
						[117.504913, 34.061648],
						[117.500432, 34.05224],
						[117.476791, 34.047613],
						[117.460251, 34.03738],
						[117.435466, 34.02833],
						[117.415638, 34.025913],
						[117.405723, 34.030078],
						[117.40029, 34.041545],
						[117.38823, 34.055582],
						[117.371119, 34.060671],
						[117.377792, 34.071466],
						[117.357153, 34.088221],
						[117.343426, 34.080563],
						[117.319498, 34.084366],
						[117.311491, 34.068073],
						[117.293807, 34.071055],
						[117.287754, 34.078662],
						[117.277029, 34.078919],
						[117.25763, 34.065914],
						[117.224742, 34.064167],
						[117.212158, 34.074704],
						[117.207058, 34.068639],
						[117.192711, 34.068742],
						[117.182082, 34.07604],
						[117.1613, 34.084315],
						[117.151434, 34.083698],
						[117.157916, 34.098755],
						[117.146572, 34.09783],
						[117.130318, 34.101787],
						[117.129985, 34.117457],
						[117.123836, 34.128193],
						[117.106439, 34.130402],
						[117.089994, 34.145707],
						[117.072311, 34.146683],
						[117.054913, 34.155105],
						[117.047049, 34.151408],
						[117.038374, 34.167428],
						[117.031558, 34.166709],
						[117.031748, 34.155721],
						[117.023312, 34.161678],
						[117.012921, 34.149508],
						[117.004913, 34.151408],
						[117.001768, 34.142318],
						[116.982177, 34.137285],
						[116.971501, 34.154643],
						[116.975457, 34.169071],
						[116.982416, 34.167274],
						[116.980176, 34.155978],
						[116.993522, 34.168352],
						[116.982416, 34.172357],
						[116.980271, 34.195867],
						[116.99538, 34.206337],
						[116.988803, 34.205208],
						[116.994666, 34.222808],
						[117.007821, 34.232967],
						[117.009584, 34.219679],
						[117.021691, 34.213675],
						[117.030175, 34.221372],
						[117.035085, 34.23189],
						[117.031081, 34.242765],
						[117.020786, 34.243329],
						[117.018879, 34.255537],
						[117.007249, 34.256973],
						[116.98437, 34.269845],
						[116.968974, 34.28369],
						[116.976648, 34.310911],
						[116.96926, 34.323109],
						[116.979651, 34.338533],
						[116.983178, 34.352468],
						[116.980223, 34.358359],
						[116.961253, 34.363277],
						[116.960967, 34.371985],
						[116.969308, 34.388833],
						[116.945667, 34.395541],
						[116.920547, 34.40701],
						[116.909203, 34.40829],
						[116.883512, 34.403068],
						[116.86702, 34.392162],
						[116.848526, 34.389038],
						[116.828078, 34.389243],
						[116.804723, 34.412744],
						[116.782654, 34.430199],
						[116.782702, 34.438285],
						[116.773693, 34.453483],
						[116.760681, 34.462591],
						[116.745095, 34.46827],
						[116.722883, 34.472669],
						[116.662588, 34.473027],
						[116.623407, 34.488628],
						[116.575123, 34.488935],
						[116.568689, 34.492515],
						[116.576792, 34.497681],
						[116.592473, 34.493845],
						[116.598956, 34.500187],
						[116.59519, 34.511539],
						[116.587707, 34.51251],
						[116.570548, 34.523401],
						[116.54805, 34.542928],
						[116.529175, 34.540679],
						[116.520643, 34.543184],
						[116.526124, 34.553354],
						[116.509585, 34.557494],
						[116.492378, 34.570576],
						[116.491425, 34.588968],
						[116.478365, 34.603832],
						[116.477221, 34.615119],
						[116.447573, 34.620532],
						[116.432845, 34.630132],
						[116.43051, 34.650809],
						[116.393379, 34.643049],
						[116.382559, 34.638659],
						[116.374218, 34.639986],
						[116.372121, 34.633451],
						[116.350958, 34.621145],
						[116.333989, 34.62089],
						[116.324981, 34.601125],
						[116.310872, 34.601432],
						[116.301101, 34.607765],
						[116.286086, 34.608838],
						[116.278651, 34.602096],
						[116.274885, 34.584626],
						[116.266067, 34.583757],
						[116.259156, 34.567612],
						[116.25296, 34.565721],
						[116.247717, 34.55177],
						[116.233417, 34.555143],
						[116.216925, 34.575123],
						[116.206296, 34.578086],
						[116.197002, 34.57594],
						[116.196334, 34.555654],
						[116.190948, 34.53567],
						[116.203818, 34.518748],
						[116.203913, 34.508675],
						[116.189471, 34.497067],
						[116.178603, 34.496044],
						[116.178842, 34.483565],
						[116.162064, 34.459419],
						[116.174933, 34.444682],
						[116.179223, 34.430506],
						[116.205295, 34.415662],
						[116.215877, 34.403324],
						[116.217068, 34.395541],
						[116.209919, 34.390216],
						[116.213589, 34.382227],
						[116.2399, 34.374545],
						[116.255629, 34.376492],
						[116.270834, 34.370704],
						[116.276792, 34.360409],
						[116.288803, 34.358923],
						[116.301577, 34.342119],
						[116.329652, 34.329719],
						[116.357678, 34.319829],
						[116.365019, 34.312397],
						[116.37336, 34.293944],
						[116.363255, 34.276255],
						[116.372216, 34.266102],
						[116.375934, 34.271281],
						[116.393951, 34.276101],
						[116.406105, 34.276512],
						[116.416258, 34.268256],
						[116.433226, 34.270153],
						[116.4307, 34.27805],
						[116.44581, 34.28815],
						[116.456868, 34.269127],
						[116.466306, 34.271179],
						[116.490138, 34.290919],
						[116.511873, 34.296456],
						[116.568975, 34.283434],
						[116.582416, 34.27523],
						[116.582321, 34.266512],
						[116.56764, 34.251229],
						[116.55396, 34.241893],
						[116.543617, 34.239533],
						[116.547144, 34.228196],
						[116.542712, 34.218858],
						[116.546143, 34.195508],
						[116.559966, 34.186166],
						[116.565495, 34.169533],
						[116.545857, 34.161061],
						[116.535991, 34.150997],
						[116.534656, 34.126601],
						[116.528031, 34.122851],
						[116.541472, 34.109956],
						[116.539613, 34.103482],
						[116.557964, 34.097779],
						[116.566877, 34.083801],
						[116.567735, 34.075938],
						[116.580319, 34.065555],
						[116.576887, 34.064064],
						[116.587421, 34.04571],
						[116.595619, 34.040106],
						[116.604199, 34.021335]
					]
				]
			]
		},
		"properties": {
			"adcode": 341300,
			"name": "宿州市",
			"center": [116.984084, 33.633891],
			"centroid": [117.213919, 33.860274],
			"cp": [117.45, 33.60],
			"childrenNum": 5,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 11,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[116.771072, 31.911286],
						[116.748479, 31.919028],
						[116.723169, 31.916711],
						[116.70234, 31.905122],
						[116.687754, 31.903437],
						[116.680509, 31.915552],
						[116.680462, 31.957259],
						[116.681939, 31.967999],
						[116.677936, 31.976263],
						[116.667735, 31.977947],
						[116.612635, 32.000947],
						[116.586801, 32.018784],
						[116.571167, 32.020468],
						[116.546858, 32.028149],
						[116.551911, 32.042036],
						[116.544046, 32.067701],
						[116.549385, 32.078848],
						[116.533131, 32.097932],
						[116.524694, 32.116434],
						[116.530224, 32.134249],
						[116.526601, 32.151746],
						[116.515495, 32.163461],
						[116.509299, 32.18468],
						[116.517068, 32.194395],
						[116.515638, 32.202692],
						[116.501101, 32.215345],
						[116.515305, 32.223377],
						[116.527554, 32.240594],
						[116.521835, 32.261113],
						[116.52641, 32.270716],
						[116.521501, 32.292539],
						[116.519261, 32.314411],
						[116.506534, 32.344403],
						[116.48418, 32.360286],
						[116.481129, 32.375276],
						[116.485371, 32.388062],
						[116.492187, 32.395817],
						[116.480176, 32.406767],
						[116.484799, 32.439347],
						[116.472359, 32.438247],
						[116.437564, 32.45092],
						[116.404819, 32.442804],
						[116.392235, 32.447621],
						[116.358489, 32.464743],
						[116.332798, 32.510385],
						[116.320071, 32.521164],
						[116.271692, 32.520955],
						[116.26397, 32.494738],
						[116.246334, 32.48406],
						[116.251244, 32.464429],
						[116.244523, 32.4549],
						[116.23561, 32.465843],
						[116.222979, 32.459193],
						[116.213065, 32.463748],
						[116.203722, 32.447621],
						[116.191187, 32.454271],
						[116.176411, 32.425363],
						[116.167879, 32.439766],
						[116.148146, 32.439923],
						[116.141854, 32.46045],
						[116.124552, 32.47113],
						[116.113398, 32.490812],
						[116.101435, 32.523833],
						[116.090948, 32.539162],
						[116.076411, 32.543974],
						[116.05663, 32.546328],
						[116.036849, 32.555011],
						[116.03113, 32.573524],
						[116.022026, 32.591563],
						[115.996954, 32.602907],
						[115.967355, 32.605103],
						[115.95234, 32.59104],
						[115.936992, 32.571955],
						[115.928365, 32.567563],
						[115.910205, 32.566987],
						[115.899433, 32.556214],
						[115.87765, 32.54387],
						[115.873027, 32.525821],
						[115.856964, 32.517973],
						[115.847336, 32.509548],
						[115.845763, 32.501803],
						[115.853055, 32.504472],
						[115.87317, 32.504734],
						[115.874457, 32.497773],
						[115.883561, 32.489242],
						[115.881273, 32.472491],
						[115.872359, 32.469769],
						[115.864257, 32.458932],
						[115.882703, 32.456104],
						[115.883275, 32.438614],
						[115.879223, 32.432591],
						[115.889423, 32.424263],
						[115.88928, 32.413473],
						[115.899099, 32.390106],
						[115.897908, 32.372289],
						[115.899242, 32.344979],
						[115.904581, 32.340995],
						[115.906964, 32.311579],
						[115.900291, 32.301404],
						[115.908251, 32.299253],
						[115.911063, 32.284199],
						[115.920072, 32.273181],
						[115.914733, 32.254869],
						[115.912731, 32.227629],
						[115.922884, 32.203637],
						[115.925267, 32.187831],
						[115.933656, 32.180426],
						[115.941949, 32.165141],
						[115.940329, 32.146755],
						[115.931368, 32.109286],
						[115.926554, 32.105239],
						[115.932512, 32.084264],
						[115.942569, 32.077692],
						[115.939614, 32.065861],
						[115.927793, 32.058761],
						[115.922216, 32.049663],
						[115.927745, 32.036303],
						[115.919547, 32.027886],
						[115.927841, 32.023572],
						[115.927603, 32.007524],
						[115.933799, 32.001631],
						[115.924552, 31.995579],
						[115.92317, 31.985474],
						[115.911349, 31.957996],
						[115.909013, 31.943253],
						[115.916115, 31.935987],
						[115.920167, 31.92045],
						[115.917259, 31.909969],
						[115.90377, 31.883522],
						[115.898337, 31.880255],
						[115.895715, 31.867503],
						[115.89295, 31.833294],
						[115.904056, 31.829393],
						[115.91316, 31.820113],
						[115.915019, 31.811888],
						[115.910253, 31.792322],
						[115.900815, 31.792006],
						[115.885229, 31.776076],
						[115.868689, 31.776551],
						[115.858298, 31.773702],
						[115.850243, 31.786731],
						[115.836468, 31.77386],
						[115.831034, 31.777606],
						[115.815353, 31.76236],
						[115.788327, 31.779821],
						[115.767927, 31.787839],
						[115.763065, 31.782353],
						[115.741997, 31.78209],
						[115.734276, 31.776023],
						[115.729843, 31.763309],
						[115.710825, 31.770906],
						[115.697145, 31.768638],
						[115.689805, 31.776551],
						[115.677793, 31.778872],
						[115.659633, 31.760196],
						[115.636564, 31.755078],
						[115.619166, 31.738351],
						[115.601435, 31.731701],
						[115.586945, 31.721726],
						[115.582655, 31.713913],
						[115.564924, 31.709004],
						[115.553485, 31.695278],
						[115.531845, 31.698551],
						[115.515067, 31.682869],
						[115.495382, 31.672942],
						[115.48542, 31.659791],
						[115.484276, 31.649068],
						[115.476983, 31.64294],
						[115.489662, 31.62577],
						[115.488232, 31.612242],
						[115.440043, 31.588723],
						[115.438852, 31.579948],
						[115.428223, 31.563401],
						[115.431559, 31.559012],
						[115.428556, 31.54722],
						[115.415877, 31.525959],
						[115.396812, 31.515168],
						[115.389614, 31.507603],
						[115.377126, 31.503],
						[115.371168, 31.494535],
						[115.377651, 31.47051],
						[115.389805, 31.45029],
						[115.385658, 31.443302],
						[115.38337, 31.418682],
						[115.373647, 31.40576],
						[115.392808, 31.38987],
						[115.38318, 31.37562],
						[115.375744, 31.371063],
						[115.382465, 31.356598],
						[115.372074, 31.349285],
						[115.3991, 31.342979],
						[115.404581, 31.337838],
						[115.420501, 31.349921],
						[115.442045, 31.346106],
						[115.449624, 31.31584],
						[115.460968, 31.318067],
						[115.457822, 31.281588],
						[115.466402, 31.276338],
						[115.473122, 31.265253],
						[115.494047, 31.265942],
						[115.501006, 31.262388],
						[115.507584, 31.267905],
						[115.51602, 31.263502],
						[115.530081, 31.249339],
						[115.53971, 31.231884],
						[115.538375, 31.220369],
						[115.540711, 31.191337],
						[115.559586, 31.160332],
						[115.585706, 31.144188],
						[115.596716, 31.150136],
						[115.603723, 31.173712],
						[115.629033, 31.184649],
						[115.636325, 31.19999],
						[115.645954, 31.209596],
						[115.655248, 31.210976],
						[115.678127, 31.207632],
						[115.700815, 31.201104],
						[115.728127, 31.174721],
						[115.740567, 31.152951],
						[115.75582, 31.142542],
						[115.764066, 31.118215],
						[115.770072, 31.113061],
						[115.781511, 31.11354],
						[115.797908, 31.127883],
						[115.813256, 31.13091],
						[115.829128, 31.126448],
						[115.841282, 31.128998],
						[115.857107, 31.143286],
						[115.869261, 31.14764],
						[115.880081, 31.141905],
						[115.886373, 31.127351],
						[115.887421, 31.109289],
						[115.902769, 31.089205],
						[115.909585, 31.090693],
						[115.925744, 31.076822],
						[115.939805, 31.071667],
						[115.942235, 31.060664],
						[115.938565, 31.047321],
						[115.946192, 31.04243],
						[115.961063, 31.046896],
						[115.983704, 31.041898],
						[115.994047, 31.034614],
						[116.00663, 31.034668],
						[116.010062, 31.017332],
						[116.015019, 31.011908],
						[116.046144, 31.014514],
						[116.051578, 31.042217],
						[116.050958, 31.049554],
						[116.066354, 31.070072],
						[116.092664, 31.082668],
						[116.093379, 31.090108],
						[116.10458, 31.094465],
						[116.11888, 31.086866],
						[116.157679, 31.099301],
						[116.166258, 31.0976],
						[116.18132, 31.083359],
						[116.183751, 31.064917],
						[116.203293, 31.0579],
						[116.222455, 31.061781],
						[116.243427, 31.0756],
						[116.261396, 31.082403],
						[116.268498, 31.100098],
						[116.293045, 31.114761],
						[116.303532, 31.123155],
						[116.309776, 31.140418],
						[116.3307, 31.145622],
						[116.342712, 31.15242],
						[116.344952, 31.163624],
						[116.359537, 31.173978],
						[116.378984, 31.165377],
						[116.395572, 31.162084],
						[116.415305, 31.162191],
						[116.431892, 31.144135],
						[116.437707, 31.128414],
						[116.4603, 31.125917],
						[116.470071, 31.135637],
						[116.481844, 31.136965],
						[116.496715, 31.148756],
						[116.501911, 31.141427],
						[116.508298, 31.142489],
						[116.519547, 31.160173],
						[116.538469, 31.174456],
						[116.543474, 31.181941],
						[116.552816, 31.179712],
						[116.556582, 31.172173],
						[116.552816, 31.165908],
						[116.558346, 31.147587],
						[116.555867, 31.123314],
						[116.562683, 31.111096],
						[116.549385, 31.093243],
						[116.538708, 31.072145],
						[116.533512, 31.056624],
						[116.534799, 31.044185],
						[116.530939, 31.035306],
						[116.530605, 31.021002],
						[116.543617, 31.020311],
						[116.560347, 31.034614],
						[116.563779, 31.045567],
						[116.571072, 31.051787],
						[116.591711, 31.04764],
						[116.594571, 31.054126],
						[116.611539, 31.067309],
						[116.614018, 31.073899],
						[116.622502, 31.074112],
						[116.647049, 31.05891],
						[116.65396, 31.052212],
						[116.665495, 31.059123],
						[116.68356, 31.055774],
						[116.68866, 31.048703],
						[116.70968, 31.043228],
						[116.722883, 31.059601],
						[116.736753, 31.063907],
						[116.752721, 31.060877],
						[116.761301, 31.068372],
						[116.777602, 31.070019],
						[116.78866, 31.065289],
						[116.805962, 31.08219],
						[116.815638, 31.085378],
						[116.829365, 31.101213],
						[116.843331, 31.104455],
						[116.842187, 31.11338],
						[116.847144, 31.124642],
						[116.862254, 31.129901],
						[116.875981, 31.127458],
						[116.894952, 31.133407],
						[116.919356, 31.151305],
						[116.92274, 31.160067],
						[116.943903, 31.161766],
						[116.946906, 31.182738],
						[116.954008, 31.189161],
						[116.963255, 31.214532],
						[116.981415, 31.244564],
						[116.998193, 31.2565],
						[117.006725, 31.267693],
						[117.016257, 31.266844],
						[117.032273, 31.256607],
						[117.045285, 31.269018],
						[117.045809, 31.282967],
						[117.063874, 31.289436],
						[117.070786, 31.301102],
						[117.070023, 31.321724],
						[117.073693, 31.335453],
						[117.081367, 31.345947],
						[117.074074, 31.360678],
						[117.074837, 31.374401],
						[117.094379, 31.408831],
						[117.113064, 31.438485],
						[117.142473, 31.472045],
						[117.149194, 31.483317],
						[117.166448, 31.490619],
						[117.184513, 31.492842],
						[117.237277, 31.490461],
						[117.250719, 31.49681],
						[117.251386, 31.502947],
						[117.242282, 31.508185],
						[117.228316, 31.544788],
						[117.220023, 31.540239],
						[117.198288, 31.551979],
						[117.187039, 31.552085],
						[117.153817, 31.545158],
						[117.144999, 31.554835],
						[117.13375, 31.551028],
						[117.132082, 31.542884],
						[117.124265, 31.54447],
						[117.112301, 31.540081],
						[117.065971, 31.553513],
						[117.055009, 31.544735],
						[117.039613, 31.538864],
						[117.006868, 31.548013],
						[117.002101, 31.56081],
						[116.990852, 31.558536],
						[116.990662, 31.537542],
						[116.987135, 31.533787],
						[116.975457, 31.540239],
						[116.966925, 31.539816],
						[116.95253, 31.532042],
						[116.934561, 31.537754],
						[116.902054, 31.528234],
						[116.879318, 31.531672],
						[116.845476, 31.526488],
						[116.829747, 31.519083],
						[116.815733, 31.531936],
						[116.806725, 31.532624],
						[116.804485, 31.539235],
						[116.792854, 31.543941],
						[116.789756, 31.550605],
						[116.767497, 31.571331],
						[116.763255, 31.58238],
						[116.766782, 31.589358],
						[116.765638, 31.618584],
						[116.754628, 31.636918],
						[116.75315, 31.647061],
						[116.757583, 31.659157],
						[116.767926, 31.672097],
						[116.763255, 31.685879],
						[116.762254, 31.711327],
						[116.752149, 31.728746],
						[116.759442, 31.7469],
						[116.758012, 31.762465],
						[116.752101, 31.765525],
						[116.731129, 31.76542],
						[116.734752, 31.77481],
						[116.728746, 31.782406],
						[116.719785, 31.779083],
						[116.714113, 31.791847],
						[116.694809, 31.809356],
						[116.692521, 31.820272],
						[116.702006, 31.832082],
						[116.732607, 31.848371],
						[116.740567, 31.857911],
						[116.724647, 31.85828],
						[116.721596, 31.87135],
						[116.714113, 31.878938],
						[116.716067, 31.884207],
						[116.764256, 31.904227],
						[116.771072, 31.911286]
					]
				]
			]
		},
		"properties": {
			"adcode": 341500,
			"name": "六安市",
			"center": [116.507676, 31.752889],
			"centroid": [116.23409, 31.659225],
			"cp": [116.23409, 31.55],
			"childrenNum": 7,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 12,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[116.393713, 33.783082],
						[116.372502, 33.780245],
						[116.361063, 33.776273],
						[116.348718, 33.778749],
						[116.3307, 33.773849],
						[116.328746, 33.76637],
						[116.31683, 33.77127],
						[116.308155, 33.757548],
						[116.284657, 33.750119],
						[116.263589, 33.730098],
						[116.246048, 33.728704],
						[116.230176, 33.734897],
						[116.226649, 33.722459],
						[116.204914, 33.726795],
						[116.197288, 33.72535],
						[116.174027, 33.708988],
						[116.155391, 33.709917],
						[116.14214, 33.734432],
						[116.14276, 33.738458],
						[116.131654, 33.752234],
						[116.109299, 33.758219],
						[116.098908, 33.774881],
						[116.099099, 33.783133],
						[116.074457, 33.781534],
						[116.073313, 33.794066],
						[116.055438, 33.804792],
						[116.06235, 33.814485],
						[116.05806, 33.821393],
						[116.045429, 33.822991],
						[116.045953, 33.829023],
						[116.063494, 33.826188],
						[116.065067, 33.847475],
						[116.056725, 33.850928],
						[116.054914, 33.860873],
						[116.043475, 33.874888],
						[116.034752, 33.873754],
						[116.034561, 33.880039],
						[116.013446, 33.885706],
						[116.012493, 33.897399],
						[115.999147, 33.901931],
						[115.98704, 33.901159],
						[115.982703, 33.917175],
						[115.995524, 33.947551],
						[116.000338, 33.963198],
						[115.994952, 33.975086],
						[115.984037, 33.987847],
						[115.957583, 34.007756],
						[115.926697, 34.007911],
						[115.919738, 34.010791],
						[115.904342, 34.009968],
						[115.899338, 34.014752],
						[115.895334, 34.028741],
						[115.887278, 34.032804],
						[115.877555, 34.029872],
						[115.877078, 34.003178],
						[115.852722, 34.003847],
						[115.845477, 34.012026],
						[115.845238, 34.03085],
						[115.832226, 34.038563],
						[115.815543, 34.052908],
						[115.809109, 34.06247],
						[115.793427, 34.063653],
						[115.780272, 34.073162],
						[115.781463, 34.062213],
						[115.768832, 34.062162],
						[115.735849, 34.076811],
						[115.705963, 34.059797],
						[115.699814, 34.066017],
						[115.681845, 34.065503],
						[115.669166, 34.056713],
						[115.65358, 34.060106],
						[115.648003, 34.046327],
						[115.649576, 34.035632],
						[115.642236, 34.032289],
						[115.621359, 34.03013],
						[115.615067, 34.033369],
						[115.601054, 34.022981],
						[115.606583, 34.013209],
						[115.592665, 34.009865],
						[115.584085, 33.988619],
						[115.591044, 33.986201],
						[115.588375, 33.97699],
						[115.579033, 33.973954],
						[115.577555, 33.950125],
						[115.569166, 33.945492],
						[115.569976, 33.932828],
						[115.562588, 33.927164],
						[115.559776, 33.914549],
						[115.568308, 33.906927],
						[115.556821, 33.903682],
						[115.555296, 33.888591],
						[115.546573, 33.888436],
						[115.546192, 33.875506],
						[115.556678, 33.876897],
						[115.564209, 33.871333],
						[115.579509, 33.877],
						[115.592331, 33.868241],
						[115.605725, 33.867417],
						[115.620882, 33.876124],
						[115.633513, 33.867314],
						[115.636135, 33.841187],
						[115.626268, 33.836187],
						[115.625601, 33.823662],
						[115.616592, 33.820001],
						[115.623313, 33.811959],
						[115.621168, 33.796799],
						[115.614257, 33.775654],
						[115.59052, 33.783701],
						[115.582226, 33.788703],
						[115.56521, 33.780193],
						[115.56316, 33.771683],
						[115.570024, 33.765286],
						[115.574838, 33.752234],
						[115.583561, 33.747229],
						[115.59624, 33.731233],
						[115.601578, 33.718537],
						[115.596287, 33.700315],
						[115.607155, 33.68906],
						[115.599624, 33.688286],
						[115.602531, 33.67264],
						[115.601626, 33.657662],
						[115.617784, 33.632608],
						[115.625029, 33.625633],
						[115.639757, 33.585115],
						[115.651244, 33.544629],
						[115.676697, 33.508729],
						[115.681273, 33.505831],
						[115.698337, 33.509557],
						[115.720834, 33.51085],
						[115.749481, 33.499881],
						[115.751387, 33.495896],
						[115.769404, 33.490515],
						[115.773217, 33.484718],
						[115.786135, 33.481044],
						[115.796049, 33.468569],
						[115.807441, 33.466861],
						[115.831606, 33.451227],
						[115.848861, 33.450864],
						[115.854962, 33.442321],
						[115.897383, 33.400525],
						[115.895334, 33.384724],
						[115.898432, 33.356999],
						[115.911111, 33.340567],
						[115.914399, 33.328902],
						[115.921406, 33.323303],
						[115.919833, 33.313606],
						[115.92603, 33.309769],
						[115.927841, 33.298722],
						[115.914828, 33.295506],
						[115.915972, 33.279478],
						[115.906725, 33.255975],
						[115.909204, 33.246634],
						[115.917498, 33.24269],
						[115.925696, 33.229195],
						[115.916497, 33.215491],
						[115.876983, 33.248295],
						[115.839423, 33.262824],
						[115.832083, 33.256753],
						[115.8297, 33.231635],
						[115.835277, 33.21383],
						[115.845238, 33.193528],
						[115.841378, 33.180234],
						[115.825505, 33.162678],
						[115.824361, 33.150938],
						[115.831034, 33.157172],
						[115.850196, 33.153535],
						[115.850196, 33.136078],
						[115.839709, 33.135454],
						[115.844333, 33.125321],
						[115.865925, 33.125581],
						[115.877126, 33.122151],
						[115.872026, 33.103128],
						[115.866735, 33.094343],
						[115.89848, 33.093667],
						[115.914876, 33.088],
						[115.948098, 33.080774],
						[115.980796, 33.07079],
						[116.002483, 33.060077],
						[116.018213, 33.056125],
						[116.010157, 33.043954],
						[116.01602, 33.041925],
						[116.04214, 33.048843],
						[116.051053, 33.044266],
						[116.0552, 33.034227],
						[116.051768, 33.021428],
						[116.059013, 33.016954],
						[116.060062, 33.003737],
						[116.052531, 32.99515],
						[116.054914, 32.99057],
						[116.083084, 32.986458],
						[116.125743, 32.976047],
						[116.155581, 32.973757],
						[116.167926, 32.967145],
						[116.165305, 32.959492],
						[116.168165, 32.940642],
						[116.178889, 32.922882],
						[116.191711, 32.91387],
						[116.198432, 32.893396],
						[116.212636, 32.888706],
						[116.232988, 32.889852],
						[116.245333, 32.884954],
						[116.248527, 32.872812],
						[116.280319, 32.859052],
						[116.292569, 32.858948],
						[116.30825, 32.86562],
						[116.348098, 32.878128],
						[116.370881, 32.900221],
						[116.386992, 32.89772],
						[116.394618, 32.891311],
						[116.393856, 32.910745],
						[116.385705, 32.921632],
						[116.365877, 32.940694],
						[116.365162, 32.946891],
						[116.371739, 32.964906],
						[116.376458, 32.969019],
						[116.376649, 32.993744],
						[116.382416, 33.004777],
						[116.446382, 32.984896],
						[116.627888, 32.941475],
						[116.684323, 32.93934],
						[116.705676, 32.936944],
						[116.735657, 32.928663],
						[116.742711, 32.94736],
						[116.740424, 32.959752],
						[116.747526, 32.978962],
						[116.754628, 32.98906],
						[116.755152, 33.002696],
						[116.76826, 33.006078],
						[116.768784, 33.000406],
						[116.778174, 33.00332],
						[116.777459, 32.996607],
						[116.79886, 32.994161],
						[116.802483, 33.000042],
						[116.810586, 32.99541],
						[116.816162, 33.013051],
						[116.814923, 33.021532],
						[116.802197, 33.032666],
						[116.781558, 33.040105],
						[116.752483, 33.053108],
						[116.748622, 33.060858],
						[116.749098, 33.075522],
						[116.764637, 33.090704],
						[116.764589, 33.114823],
						[116.754723, 33.13109],
						[116.756868, 33.141222],
						[116.77131, 33.15525],
						[116.777078, 33.151821],
						[116.791853, 33.169015],
						[116.805247, 33.156081],
						[116.815304, 33.155405],
						[116.821405, 33.202771],
						[116.826553, 33.210819],
						[116.825981, 33.230804],
						[116.813159, 33.250319],
						[116.805485, 33.275587],
						[116.800481, 33.27595],
						[116.801911, 33.303908],
						[116.789089, 33.319777],
						[116.790424, 33.334553],
						[116.787421, 33.347254],
						[116.794141, 33.354822],
						[116.790948, 33.360005],
						[116.800862, 33.386122],
						[116.796572, 33.403012],
						[116.804628, 33.422902],
						[116.7705, 33.431861],
						[116.756725, 33.438438],
						[116.745905, 33.449104],
						[116.722597, 33.450709],
						[116.700004, 33.474056],
						[116.687182, 33.47799],
						[116.665733, 33.474626],
						[116.642378, 33.477628],
						[116.63642, 33.484977],
						[116.623503, 33.485495],
						[116.612778, 33.481872],
						[116.593617, 33.480112],
						[116.58213, 33.471209],
						[116.56826, 33.466292],
						[116.547478, 33.467897],
						[116.535562, 33.481302],
						[116.533989, 33.498018],
						[116.539089, 33.513178],
						[116.534656, 33.525077],
						[116.524742, 33.53056],
						[116.52846, 33.544008],
						[116.525505, 33.551455],
						[116.531939, 33.565624],
						[116.548002, 33.57007],
						[116.540662, 33.587596],
						[116.55153, 33.588578],
						[116.551101, 33.596642],
						[116.543808, 33.59783],
						[116.533751, 33.614575],
						[116.505486, 33.618968],
						[116.503817, 33.631265],
						[116.481129, 33.654253],
						[116.485848, 33.666081],
						[116.49214, 33.668405],
						[116.492426, 33.681315],
						[116.484227, 33.697889],
						[116.478603, 33.697992],
						[116.479413, 33.708678],
						[116.463589, 33.719724],
						[116.460014, 33.734123],
						[116.433226, 33.739696],
						[116.435753, 33.762191],
						[116.406439, 33.762552],
						[116.408155, 33.770393],
						[116.393713, 33.783082]
					]
				]
			]
		},
		"properties": {
			"adcode": 341600,
			"name": "亳州市",
			"center": [115.782939, 33.869338],
			"centroid": [116.185025, 33.435253],
			"cp": [116.32, 33.32],
			"childrenNum": 4,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 13,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": [
				[
					[116.673836, 29.709848],
					[116.687087, 29.734798],
					[116.703055, 29.741264],
					[116.720548, 29.763352],
					[116.739327, 29.774179],
					[116.745857, 29.790336],
					[116.762492, 29.802506],
					[116.780891, 29.79249],
					[116.789804, 29.795128],
					[116.812349, 29.811713],
					[116.830748, 29.841482],
					[116.861301, 29.867369],
					[116.882702, 29.893518],
					[116.891996, 29.919337],
					[116.891853, 29.92735],
					[116.900147, 29.949504],
					[116.887897, 29.968805],
					[116.868688, 29.980469],
					[116.845381, 29.969611],
					[116.835943, 29.970686],
					[116.835276, 29.95773],
					[116.828746, 29.963106],
					[116.829556, 30.006534],
					[116.802816, 29.996539],
					[116.787325, 30.020343],
					[116.783512, 30.030712],
					[116.770309, 30.035655],
					[116.764542, 30.048923],
					[116.753627, 30.048976],
					[116.747335, 30.057248],
					[116.771787, 30.073681],
					[116.816925, 30.115075],
					[116.841901, 30.146739],
					[116.860061, 30.17732],
					[116.867497, 30.213576],
					[116.892711, 30.240492],
					[116.920547, 30.257966],
					[116.927173, 30.273455],
					[116.928793, 30.290978],
					[116.9205, 30.314283],
					[116.910347, 30.332869],
					[116.903341, 30.357289],
					[116.893855, 30.381595],
					[116.888279, 30.407019],
					[116.891949, 30.414725],
					[116.892425, 30.431099],
					[116.9011, 30.436503],
					[116.914446, 30.425481],
					[116.935609, 30.440301],
					[116.950433, 30.442816],
					[116.975552, 30.458062],
					[116.986372, 30.470791],
					[117.01049, 30.489294],
					[117.025457, 30.494267],
					[117.111586, 30.495337],
					[117.135133, 30.492075],
					[117.164017, 30.474802],
					[117.192187, 30.465871],
					[117.213397, 30.476941],
					[117.226315, 30.489027],
					[117.236372, 30.504747],
					[117.241281, 30.523083],
					[117.243807, 30.538156],
					[117.252244, 30.563967],
					[117.247906, 30.58929],
					[117.21783, 30.620641],
					[117.217068, 30.630626],
					[117.272644, 30.656626],
					[117.309489, 30.676801],
					[117.343426, 30.688969],
					[117.366829, 30.694251],
					[117.394379, 30.694998],
					[117.399384, 30.690676],
					[117.422358, 30.682885],
					[117.4511, 30.679043],
					[117.470404, 30.678989],
					[117.485418, 30.686514],
					[117.493616, 30.696706],
					[117.507249, 30.726688],
					[117.576934, 30.756662],
					[117.645523, 30.776603],
					[117.670594, 30.781508],
					[117.701815, 30.806614],
					[117.698526, 30.789931],
					[117.72088, 30.791103],
					[117.742568, 30.8072],
					[117.751529, 30.802936],
					[117.755961, 30.792223],
					[117.748478, 30.778522],
					[117.759918, 30.769832],
					[117.758202, 30.761674],
					[117.781938, 30.764127],
					[117.78375, 30.749729],
					[117.796238, 30.748449],
					[117.803101, 30.757462],
					[117.815733, 30.759914],
					[117.842282, 30.773617],
					[117.846333, 30.788438],
					[117.872787, 30.807893],
					[117.884036, 30.812317],
					[117.903197, 30.814022],
					[117.915828, 30.819564],
					[117.934608, 30.835763],
					[117.94333, 30.833099],
					[117.953626, 30.817593],
					[117.980413, 30.843808],
					[117.989612, 30.828836],
					[117.966781, 30.799099],
					[117.968783, 30.794941],
					[117.983702, 30.794035],
					[117.997477, 30.778949],
					[118.030461, 30.774097],
					[118.051671, 30.758635],
					[118.071357, 30.746849],
					[118.095952, 30.738849],
					[118.115732, 30.71938],
					[118.124979, 30.717833],
					[118.128506, 30.701295],
					[118.134941, 30.700281],
					[118.126075, 30.690783],
					[118.105723, 30.662978],
					[118.099574, 30.651341],
					[118.100956, 30.641251],
					[118.077934, 30.623684],
					[118.073073, 30.609533],
					[118.065923, 30.600026],
					[118.046142, 30.597142],
					[118.022977, 30.575454],
					[117.997048, 30.570806],
					[117.985132, 30.561348],
					[117.987229, 30.537675],
					[117.98108, 30.525382],
					[117.970118, 30.512231],
					[117.963635, 30.508436],
					[117.951481, 30.489134],
					[117.945904, 30.466726],
					[117.945904, 30.455066],
					[117.938564, 30.425106],
					[117.941233, 30.413602],
					[117.952911, 30.403594],
					[117.953197, 30.392568],
					[117.938278, 30.378115],
					[117.91659, 30.366552],
					[117.928125, 30.357289],
					[117.940137, 30.33469],
					[117.925361, 30.33078],
					[117.932034, 30.326335],
					[117.928507, 30.319747],
					[117.920356, 30.320014],
					[117.907677, 30.309783],
					[117.91292, 30.299283],
					[117.902196, 30.294246],
					[117.886419, 30.293228],
					[117.888516, 30.269597],
					[117.863206, 30.266435],
					[117.842997, 30.260378],
					[117.824932, 30.241617],
					[117.829317, 30.225212],
					[117.858345, 30.21733],
					[117.8613, 30.209072],
					[117.852863, 30.191749],
					[117.846953, 30.192286],
					[117.831366, 30.182202],
					[117.820404, 30.182577],
					[117.797811, 30.163694],
					[117.778125, 30.156719],
					[117.743187, 30.154037],
					[117.698955, 30.143466],
					[117.682606, 30.132733],
					[117.68661, 30.126132],
					[117.673264, 30.122106],
					[117.676219, 30.107936],
					[117.662491, 30.108902],
					[117.655866, 30.115451],
					[117.646143, 30.114484],
					[117.642901, 30.105627],
					[117.631176, 30.099293],
					[117.615351, 30.111693],
					[117.61049, 30.131499],
					[117.599765, 30.129781],
					[117.584846, 30.118027],
					[117.572739, 30.115719],
					[117.568736, 30.107399],
					[117.560299, 30.103748],
					[117.571071, 30.101762],
					[117.56845, 30.088233],
					[117.559965, 30.0834],
					[117.554293, 30.101601],
					[117.545618, 30.101601],
					[117.541043, 30.11062],
					[117.528983, 30.099561],
					[117.535371, 30.083776],
					[117.544093, 30.086783],
					[117.53599, 30.076581],
					[117.542091, 30.052844],
					[117.511491, 30.037105],
					[117.492806, 30.034903],
					[117.461777, 30.037965],
					[117.446476, 30.02303],
					[117.433273, 30.02072],
					[117.411538, 30.030444],
					[117.394093, 30.029745],
					[117.386372, 30.011048],
					[117.349813, 30.008254],
					[117.324217, 29.99799],
					[117.309155, 29.999065],
					[117.297668, 29.992777],
					[117.267401, 29.98321],
					[117.260156, 29.985253],
					[117.206152, 29.974288],
					[117.203102, 29.965149],
					[117.206248, 29.927511],
					[117.188946, 29.921864],
					[117.177601, 29.921972],
					[117.148812, 29.911323],
					[117.134704, 29.903846],
					[117.127983, 29.895508],
					[117.133035, 29.874256],
					[117.127697, 29.861611],
					[117.110395, 29.855422],
					[117.092807, 29.836853],
					[117.073312, 29.832224],
					[117.0756, 29.822642],
					[117.092711, 29.809559],
					[117.127983, 29.795775],
					[117.135609, 29.780965],
					[117.135466, 29.772024],
					[117.108679, 29.751985],
					[117.10825, 29.745089],
					[117.122454, 29.728548],
					[117.113016, 29.712165],
					[117.085848, 29.696912],
					[117.070881, 29.693732],
					[117.051243, 29.682896],
					[117.042044, 29.680902],
					[117.015304, 29.685753],
					[116.996048, 29.683381],
					[116.984561, 29.674702],
					[116.971167, 29.655668],
					[116.939613, 29.64828],
					[116.918545, 29.634473],
					[116.873455, 29.609282],
					[116.848955, 29.576421],
					[116.838088, 29.569837],
					[116.818403, 29.564764],
					[116.795762, 29.566545],
					[116.780652, 29.570539],
					[116.779651, 29.57804],
					[116.786944, 29.591315],
					[116.774933, 29.595254],
					[116.770166, 29.592232],
					[116.760443, 29.599085],
					[116.740185, 29.585919],
					[116.729985, 29.568542],
					[116.721596, 29.56498],
					[116.716544, 29.590775],
					[116.688946, 29.604103],
					[116.685657, 29.611602],
					[116.670595, 29.625088],
					[116.651911, 29.63717],
					[116.652244, 29.645422],
					[116.663589, 29.659173],
					[116.677078, 29.66904],
					[116.680509, 29.681495],
					[116.673026, 29.687532],
					[116.656677, 29.686346],
					[116.654151, 29.694756],
					[116.668021, 29.700308],
					[116.673836, 29.709848]
				],
				[
					[116.698956, 29.7078],
					[116.705819, 29.697128],
					[116.703388, 29.710063],
					[116.698956, 29.7078]
				],
				[
					[116.706534, 29.696588],
					[116.705057, 29.688664],
					[116.717163, 29.690767],
					[116.715876, 29.697289],
					[116.706534, 29.696588]
				],
				[
					[117.297144, 30.487209],
					[117.290137, 30.4763],
					[117.274456, 30.465229],
					[117.256724, 30.458543],
					[117.25558, 30.45405],
					[117.267211, 30.441746],
					[117.259203, 30.430511],
					[117.25253, 30.428798],
					[117.251958, 30.420558],
					[117.268545, 30.420184],
					[117.281129, 30.414458],
					[117.299289, 30.425374],
					[117.293378, 30.440997],
					[117.305437, 30.445812],
					[117.31478, 30.461859],
					[117.321882, 30.462234],
					[117.326648, 30.470631],
					[117.324551, 30.487637],
					[117.319784, 30.49277],
					[117.307535, 30.494267],
					[117.297144, 30.487209]
				]
			]
		},
		"properties": {
			"adcode": 341700,
			"name": "池州市",
			"center": [117.489157, 30.656037],
			"centroid": [117.371465, 30.282082],
			"cp": [117.371465, 30.3],		
			"childrenNum": 4,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 14,
			"acroutes": [100000, 340000]
		}
	}, {
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[118.868878, 30.10144],
						[118.871642, 30.113035],
						[118.887228, 30.117437],
						[118.888134, 30.127259],
						[118.895951, 30.138797],
						[118.896809, 30.148081],
						[118.881032, 30.146793],
						[118.865732, 30.151515],
						[118.856389, 30.148188],
						[118.845713, 30.156129],
						[118.852862, 30.166537],
						[118.864397, 30.169005],
						[118.910822, 30.187512],
						[118.920641, 30.199043],
						[118.929888, 30.203387],
						[118.924979, 30.213844],
						[118.903196, 30.21792],
						[118.893043, 30.242689],
						[118.882414, 30.24746],
						[118.889707, 30.254268],
						[118.878077, 30.282726],
						[118.881795, 30.298532],
						[118.879888, 30.314872],
						[118.899764, 30.322586],
						[118.908391, 30.330888],
						[118.917877, 30.332441],
						[118.936323, 30.34508],
						[118.936418, 30.35081],
						[118.955388, 30.359216],
						[118.959964, 30.347275],
						[118.96902, 30.351345],
						[118.975741, 30.347168],
						[118.988086, 30.348668],
						[118.988039, 30.333458],
						[119.004435, 30.328959],
						[119.028792, 30.312569],
						[119.048334, 30.312676],
						[119.05086, 30.306729],
						[119.063015, 30.304961],
						[119.073405, 30.31589],
						[119.090231, 30.324032],
						[119.111013, 30.311283],
						[119.128506, 30.304694],
						[119.151289, 30.304586],
						[119.156723, 30.29955],
						[119.188181, 30.291674],
						[119.201051, 30.291031],
						[119.205674, 30.301586],
						[119.222595, 30.299604],
						[119.229173, 30.289692],
						[119.236227, 30.2973],
						[119.245903, 30.321621],
						[119.239993, 30.327031],
						[119.247142, 30.340796],
						[119.265064, 30.338064],
						[119.278124, 30.341599],
						[119.289468, 30.349632],
						[119.300669, 30.36366],
						[119.329077, 30.371531],
						[119.342662, 30.363178],
						[119.34943, 30.34915],
						[119.375598, 30.354826],
						[119.386132, 30.363928],
						[119.399954, 30.367783],
						[119.403052, 30.374368],
						[119.393806, 30.38304],
						[119.371451, 30.38395],
						[119.366589, 30.388393],
						[119.368925, 30.39974],
						[119.363205, 30.409481],
						[119.349525, 30.408625],
						[119.352957, 30.424839],
						[119.349716, 30.438803],
						[119.336132, 30.445544],
						[119.334463, 30.478118],
						[119.330317, 30.488225],
						[119.336322, 30.507153],
						[119.328696, 30.52164],
						[119.326551, 30.533025],
						[119.313634, 30.531208],
						[119.287943, 30.512606],
						[119.272118, 30.510521],
						[119.261632, 30.517738],
						[119.261918, 30.525542],
						[119.242566, 30.530032],
						[119.236942, 30.546707],
						[119.245522, 30.561402],
						[119.264778, 30.573424],
						[119.264778, 30.582025],
						[119.254149, 30.588649],
						[119.253672, 30.596447],
						[119.239135, 30.609319],
						[119.25005, 30.620267],
						[119.258772, 30.614393],
						[119.275741, 30.617597],
						[119.291232, 30.616048],
						[119.311966, 30.621228],
						[119.323119, 30.630306],
						[119.333653, 30.652195],
						[119.343138, 30.664205],
						[119.35453, 30.666927],
						[119.372357, 30.680377],
						[119.379411, 30.679363],
						[119.391518, 30.685233],
						[119.395665, 30.678722],
						[119.400002, 30.658868],
						[119.412681, 30.642959],
						[119.433653, 30.644454],
						[119.448286, 30.655825],
						[119.452909, 30.671624],
						[119.466017, 30.683899],
						[119.482747, 30.704442],
						[119.479697, 30.736823],
						[119.484606, 30.744609],
						[119.478791, 30.753089],
						[119.480126, 30.773298],
						[119.491518, 30.777243],
						[119.507104, 30.769619],
						[119.524501, 30.776017],
						[119.55453, 30.825639],
						[119.561203, 30.829476],
						[119.575741, 30.829742],
						[119.573739, 30.853344],
						[119.558963, 30.871189],
						[119.559058, 30.891745],
						[119.556341, 30.896697],
						[119.563825, 30.919218],
						[119.580364, 30.929173],
						[119.582175, 30.947428],
						[119.580412, 30.967117],
						[119.588372, 30.979142],
						[119.607437, 30.991856],
						[119.616255, 31.002388],
						[119.624025, 31.005313],
						[119.634034, 31.01946],
						[119.631317, 31.046311],
						[119.634987, 31.064172],
						[119.629554, 31.085538],
						[119.634702, 31.093775],
						[119.649144, 31.105092],
						[119.624168, 31.115983],
						[119.623786, 31.130273],
						[119.613729, 31.129157],
						[119.599763, 31.109183],
						[119.581985, 31.108652],
						[119.57412, 31.113965],
						[119.571308, 31.128998],
						[119.56025, 31.140736],
						[119.545855, 31.147853],
						[119.534511, 31.158102],
						[119.5235, 31.159748],
						[119.51392, 31.156031],
						[119.494473, 31.163996],
						[119.48556, 31.161394],
						[119.482509, 31.152526],
						[119.475836, 31.158898],
						[119.460583, 31.156403],
						[119.454768, 31.164899],
						[119.438801, 31.177057],
						[119.423167, 31.181835],
						[119.415398, 31.172969],
						[119.400622, 31.178756],
						[119.39147, 31.174243],
						[119.389325, 31.188365],
						[119.405674, 31.194416],
						[119.394902, 31.199618],
						[119.379173, 31.189214],
						[119.371403, 31.197707],
						[119.365779, 31.195956],
						[119.360059, 31.212144],
						[119.365207, 31.232627],
						[119.379697, 31.26939],
						[119.371594, 31.271617],
						[119.367876, 31.289224],
						[119.356627, 31.303275],
						[119.350145, 31.301049],
						[119.350288, 31.281641],
						[119.345951, 31.268965],
						[119.337562, 31.258888],
						[119.333224, 31.264139],
						[119.314873, 31.26573],
						[119.294473, 31.263131],
						[119.266971, 31.250453],
						[119.261394, 31.261328],
						[119.249764, 31.262017],
						[119.250193, 31.257243],
						[119.238563, 31.254644],
						[119.236275, 31.259312],
						[119.218544, 31.264563],
						[119.215255, 31.27411],
						[119.204244, 31.26573],
						[119.197142, 31.273527],
						[119.199478, 31.293625],
						[119.181127, 31.300465],
						[119.176218, 31.293944],
						[119.158153, 31.294792],
						[119.150098, 31.277133],
						[119.14066, 31.276019],
						[119.131747, 31.262548],
						[119.120021, 31.261699],
						[119.107009, 31.250612],
						[119.105293, 31.23528],
						[119.085465, 31.240267],
						[119.073787, 31.232892],
						[119.062347, 31.238463],
						[119.048858, 31.233529],
						[119.039516, 31.23841],
						[119.022881, 31.238145],
						[119.015017, 31.241646],
						[119.003291, 31.233741],
						[118.986466, 31.231141],
						[118.983939, 31.237773],
						[118.953053, 31.237773],
						[118.924979, 31.239683],
						[118.915207, 31.244193],
						[118.891232, 31.237986],
						[118.869688, 31.24223],
						[118.851051, 31.23963],
						[118.824073, 31.230451],
						[118.819116, 31.236022],
						[118.802672, 31.228223],
						[118.795331, 31.229443],
						[118.781413, 31.239843],
						[118.779983, 31.259524],
						[118.761394, 31.277663],
						[118.726599, 31.282224],
						[118.707915, 31.296807],
						[118.704435, 31.302798],
						[118.719593, 31.294792],
						[118.72107, 31.322679],
						[118.714731, 31.321671],
						[118.704102, 31.307782],
						[118.692186, 31.309001],
						[118.681747, 31.304336],
						[118.656866, 31.304654],
						[118.661442, 31.290762],
						[118.66006, 31.269761],
						[118.651861, 31.261009],
						[118.647286, 31.245519],
						[118.663587, 31.236871],
						[118.66821, 31.22488],
						[118.682986, 31.214054],
						[118.695045, 31.189108],
						[118.708963, 31.177004],
						[118.718401, 31.173978],
						[118.733558, 31.149446],
						[118.717305, 31.144188],
						[118.702004, 31.135797],
						[118.690327, 31.124961],
						[118.683082, 31.111893],
						[118.685513, 31.096272],
						[118.676838, 31.08963],
						[118.676123, 31.081393],
						[118.682653, 31.074909],
						[118.663396, 31.054445],
						[118.650003, 31.036848],
						[118.627314, 31.020576],
						[118.606819, 31.020204],
						[118.600956, 31.028021],
						[118.603768, 31.044238],
						[118.596142, 31.047853],
						[118.584273, 31.026107],
						[118.572262, 31.016269],
						[118.581223, 30.994728],
						[118.582462, 30.981855],
						[118.570975, 30.972278],
						[118.550956, 30.970682],
						[118.510251, 30.9511],
						[118.515255, 30.937582],
						[118.495713, 30.941042],
						[118.509154, 30.928694],
						[118.511537, 30.914054],
						[118.489707, 30.900052],
						[118.492948, 30.883491],
						[118.485846, 30.87726],
						[118.475742, 30.88184],
						[118.472119, 30.875077],
						[118.483987, 30.870762],
						[118.47741, 30.857553],
						[118.485513, 30.864051],
						[118.498239, 30.859843],
						[118.490041, 30.848656],
						[118.490899, 30.842849],
						[118.477982, 30.833579],
						[118.482224, 30.822549],
						[118.495522, 30.819884],
						[118.503101, 30.810451],
						[118.502863, 30.801497],
						[118.48475, 30.79025],
						[118.480699, 30.780602],
						[118.48027, 30.76642],
						[118.451671, 30.779162],
						[118.455198, 30.790144],
						[118.446476, 30.800911],
						[118.4317, 30.796434],
						[118.419498, 30.813649],
						[118.429841, 30.813916],
						[118.4368, 30.824733],
						[118.424502, 30.841091],
						[118.409536, 30.84871],
						[118.376409, 30.845513],
						[118.358916, 30.84578],
						[118.34762, 30.824414],
						[118.33823, 30.826812],
						[118.318687, 30.821749],
						[118.306724, 30.806934],
						[118.312872, 30.795101],
						[118.305008, 30.800964],
						[118.302577, 30.793822],
						[118.307582, 30.77639],
						[118.297906, 30.772391],
						[118.294569, 30.757088],
						[118.276647, 30.743169],
						[118.275694, 30.736449],
						[118.294712, 30.722421],
						[118.297191, 30.715966],
						[118.314445, 30.705083],
						[118.30496, 30.698146],
						[118.293282, 30.699961],
						[118.278745, 30.712659],
						[118.267591, 30.714206],
						[118.242901, 30.703482],
						[118.229221, 30.709244],
						[118.218354, 30.709458],
						[118.205437, 30.702148],
						[118.171214, 30.691637],
						[118.153578, 30.666554],
						[118.1368, 30.652195],
						[118.100956, 30.641251],
						[118.077934, 30.623684],
						[118.073073, 30.609533],
						[118.065923, 30.600026],
						[118.046142, 30.597142],
						[118.022977, 30.575454],
						[117.997048, 30.570806],
						[117.985132, 30.561348],
						[117.987229, 30.537675],
						[117.98108, 30.525382],
						[117.970118, 30.512231],
						[117.985751, 30.498705],
						[118.016924, 30.500576],
						[118.034941, 30.498438],
						[118.053721, 30.503677],
						[118.075218, 30.515011],
						[118.089612, 30.51731],
						[118.117591, 30.509238],
						[118.130747, 30.49817],
						[118.121118, 30.493091],
						[118.118211, 30.483252],
						[118.103435, 30.465229],
						[118.109774, 30.452712],
						[118.107582, 30.42928],
						[118.125027, 30.423662],
						[118.130175, 30.429601],
						[118.142901, 30.433828],
						[118.15782, 30.434309],
						[118.163254, 30.446775],
						[118.181128, 30.447844],
						[118.16864, 30.453033],
						[118.188039, 30.474481],
						[118.185847, 30.46448],
						[118.196571, 30.468652],
						[118.21373, 30.466833],
						[118.213873, 30.461271],
						[118.225217, 30.455013],
						[118.231604, 30.445651],
						[118.228077, 30.439713],
						[118.215399, 30.438322],
						[118.222977, 30.423929],
						[118.221452, 30.414351],
						[118.237801, 30.40049],
						[118.250337, 30.394816],
						[118.255913, 30.378437],
						[118.265684, 30.376402],
						[118.278173, 30.38031],
						[118.280365, 30.372387],
						[118.300289, 30.370139],
						[118.295141, 30.358306],
						[118.305532, 30.351399],
						[118.299765, 30.340796],
						[118.302052, 30.329709],
						[118.310203, 30.32055],
						[118.307629, 30.309301],
						[118.294903, 30.302122],
						[118.31211, 30.292907],
						[118.320546, 30.293764],
						[118.304912, 30.284387],
						[118.292472, 30.283691],
						[118.271404, 30.269865],
						[118.266638, 30.259842],
						[118.267782, 30.243333],
						[118.271881, 30.238186],
						[118.286562, 30.232879],
						[118.289946, 30.219046],
						[118.290708, 30.199526],
						[118.31149, 30.193197],
						[118.326647, 30.175282],
						[118.339326, 30.16584],
						[118.347477, 30.134289],
						[118.356962, 30.121945],
						[118.355103, 30.111908],
						[118.370642, 30.099722],
						[118.384607, 30.097145],
						[118.394807, 30.106271],
						[118.404483, 30.099615],
						[118.417734, 30.097306],
						[118.449955, 30.102621],
						[118.468926, 30.082434],
						[118.477696, 30.076527],
						[118.494474, 30.072124],
						[118.514016, 30.038932],
						[118.513492, 30.030659],
						[118.498096, 30.018141],
						[118.498716, 30.005997],
						[118.50577, 29.99138],
						[118.509297, 29.998312],
						[118.520403, 29.99885],
						[118.524502, 29.992508],
						[118.520784, 29.975201],
						[118.524741, 29.967407],
						[118.548668, 29.945203],
						[118.564588, 29.947569],
						[118.574931, 29.963751],
						[118.583463, 29.968321],
						[118.605818, 29.971654],
						[118.614016, 29.980469],
						[118.618592, 29.997399],
						[118.614493, 30.001805],
						[118.628029, 30.016529],
						[118.651004, 30.024534],
						[118.669021, 30.023675],
						[118.688754, 30.028993],
						[118.694807, 30.036675],
						[118.69781, 30.056818],
						[118.730365, 30.070298],
						[118.743139, 30.092743],
						[118.754626, 30.080608],
						[118.767972, 30.076796],
						[118.789945, 30.078299],
						[118.82107, 30.102728],
						[118.85005, 30.110458],
						[118.868878, 30.10144]
					]
				]
			]
		},
		"properties": {
			"adcode": 341800,
			"name": "宣城市",
			"center": [118.757995, 30.945667],
			"centroid": [118.857477, 30.684955],
			"childrenNum": 7,
			"level": "city",
			"parent": "{ \"adcode\": 340000 }",
			"subFeatureIndex": 15,
			"acroutes": [100000, 340000]
		}
	}]
}
